"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7092],{

/***/ 65253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JC": function() { return /* binding */ getSiteReviews; },
/* harmony export */   "e6": function() { return /* binding */ parseImage; },
/* harmony export */   "lh": function() { return /* binding */ contentURL; },
/* harmony export */   "nK": function() { return /* binding */ parseContent; },
/* harmony export */   "qf": function() { return /* binding */ populateString; }
/* harmony export */ });
/* unused harmony export shortPopulateString */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);



var contentURL = "https://cms.akupanel-store.nl/" || 0;
var shortPopulateString = "populate[0]=seo&populate[1]=seo.metaImage";
var populateString = "populate[0]=content&populate[1]=content.image&populate[2]=content.image2&populate[3]=content.cta&populate[4]=seo&populate[5]=seo.metaImage&populate[6]=seo.metaSocial&populate[7]=seo.metaSocial.image&populate[8]=content.firstImage&populate[9]=content.secondImage&populate[10]=content.accordion&populate[11]=content.bannerImage&populate[12]=content.Blocks&populate[13]=content.Blocks.backgroundImage&populate[14]=content.Blocks.cta&populate[15]=content.product_collections&populate[16]=content.products&populate[17]=content.items&populate[18]=usps";
var getSiteReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
        var res, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("".concat(contentURL, "api/google-reviews?filters[visible][$eq]=true"))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        data === null || data === void 0 ? void 0 : data.data.map(function(o) {
                            return o === null || o === void 0 ? void 0 : o.attributes;
                        })
                    ];
            }
        });
    });
    return function getSiteReviews() {
        return _ref.apply(this, arguments);
    };
}();
var parseContent = function(item) {
    switch(item["__component"]){
        case "shared.hero":
            var ref;
            var _title, _titleType, ref1, _content;
            var heroSection = {
                id: item.id,
                type: "hero",
                title: (_title = item.title) !== null && _title !== void 0 ? _title : item.Title,
                subTitle: item.subTitle,
                titleType: (ref1 = (_titleType = item.titleType) !== null && _titleType !== void 0 ? _titleType : item.titletype) !== null && ref1 !== void 0 ? ref1 : "h2",
                content: (_content = item.content) !== null && _content !== void 0 ? _content : "",
                image: parseImage(item.firstImage),
                image2: parseImage(item.secondImage)
            };
            if ((item === null || item === void 0 ? void 0 : item.cta) && (item === null || item === void 0 ? void 0 : (ref = item.cta) === null || ref === void 0 ? void 0 : ref.ctaText)) heroSection.cta = item.cta;
            return heroSection;
            break;
        case "shared.blocks":
            var _amountPerRow;
            var blockSection = {
                id: item.id,
                type: "blocks",
                amountPerRow: (_amountPerRow = item.amountPerRow) !== null && _amountPerRow !== void 0 ? _amountPerRow : 3,
                blocks: item === null || item === void 0 ? void 0 : item.Blocks.map(function(block) {
                    var ref;
                    var _title, ref1, _wholeClick;
                    var data = {
                        id: block.id,
                        title: (_title = block.title) !== null && _title !== void 0 ? _title : "",
                        cta: (ref1 = block === null || block === void 0 ? void 0 : block.cta) !== null && ref1 !== void 0 ? ref1 : null,
                        wholeClick: (_wholeClick = block.wholeClick) !== null && _wholeClick !== void 0 ? _wholeClick : false
                    };
                    if (block === null || block === void 0 ? void 0 : (ref = block.backgroundImage) === null || ref === void 0 ? void 0 : ref.data) data.image = parseImage(block.backgroundImage);
                    return data;
                })
            };
            //if (item?.cta && item?.cta?.ctaText) blockSection.cta = item.cta
            return blockSection;
            break;
        case "shared.two-image":
            var ref2;
            var _titleType1, ref3, _accordion, ref4, ref5;
            var twoImage = {
                id: item.id,
                type: "two-image",
                title: item.title,
                titleType: (ref3 = (_titleType1 = item.titleType) !== null && _titleType1 !== void 0 ? _titleType1 : item.titletype) !== null && ref3 !== void 0 ? ref3 : "h2",
                content: item.content,
                accordion: (_accordion = item.accordion) !== null && _accordion !== void 0 ? _accordion : [],
                faqitem: (ref4 = item === null || item === void 0 ? void 0 : item.faqitem) !== null && ref4 !== void 0 ? ref4 : false,
                image: parseImage(item.image),
                image2: parseImage(item.image2),
                imageLocation: item.imageLocation,
                titleVertical: (ref5 = item === null || item === void 0 ? void 0 : item.titleVertical) !== null && ref5 !== void 0 ? ref5 : "top"
            };
            if ((item === null || item === void 0 ? void 0 : item.cta) && (item === null || item === void 0 ? void 0 : (ref2 = item.cta) === null || ref2 === void 0 ? void 0 : ref2.ctaText)) twoImage.cta = item.cta;
            return twoImage;
            break;
        case "shared.one-image":
            var ref6;
            var _titleType2, ref7, _accordion1, ref8, ref9;
            var oneImage = {
                id: item.id,
                type: "one-image",
                title: item.title,
                titleType: (ref7 = (_titleType2 = item.titleType) !== null && _titleType2 !== void 0 ? _titleType2 : item.titletype) !== null && ref7 !== void 0 ? ref7 : "h2",
                content: item.content,
                accordion: (_accordion1 = item.accordion) !== null && _accordion1 !== void 0 ? _accordion1 : [],
                faqitem: (ref8 = item === null || item === void 0 ? void 0 : item.faqitem) !== null && ref8 !== void 0 ? ref8 : false,
                image: parseImage(item.image),
                imageLocation: item.imageLocation,
                titleVertical: (ref9 = item === null || item === void 0 ? void 0 : item.titleVertical) !== null && ref9 !== void 0 ? ref9 : "top"
            };
            if ((item === null || item === void 0 ? void 0 : item.cta) && (item === null || item === void 0 ? void 0 : (ref6 = item.cta) === null || ref6 === void 0 ? void 0 : ref6.ctaText)) oneImage.cta = item.cta;
            return oneImage;
            break;
        case "shared.banner":
            var ref10;
            var banner = {
                id: item.id,
                type: "banner",
                title: item.title,
                content: item.description,
                image: parseImage(item.bannerImage)
            };
            if ((item === null || item === void 0 ? void 0 : item.cta) && (item === null || item === void 0 ? void 0 : (ref10 = item.cta) === null || ref10 === void 0 ? void 0 : ref10.ctaText)) banner.cta = item.cta;
            return banner;
            break;
        case "shared.reviews":
            var reviews = {
                id: item.id,
                type: "reviews",
                title: item.title,
                show_title: item.show_title
            };
            return reviews;
            break;
        default:
        case "shared.full-text":
            var ref11;
            var _titleType3, ref12, _accordion2, ref13, ref14;
            var fullText = {
                id: item.id,
                type: "full-text",
                title: item.title,
                titleType: (ref12 = (_titleType3 = item.titleType) !== null && _titleType3 !== void 0 ? _titleType3 : item.titletype) !== null && ref12 !== void 0 ? ref12 : "h2",
                content: item.content,
                accordion: (_accordion2 = item.accordion) !== null && _accordion2 !== void 0 ? _accordion2 : [],
                faqitem: (ref13 = item === null || item === void 0 ? void 0 : item.faqitem) !== null && ref13 !== void 0 ? ref13 : false,
                layout: item.layout,
                titleVertical: (ref14 = item === null || item === void 0 ? void 0 : item.titleVertical) !== null && ref14 !== void 0 ? ref14 : "top"
            };
            if ((item === null || item === void 0 ? void 0 : item.cta) && (item === null || item === void 0 ? void 0 : (ref11 = item.cta) === null || ref11 === void 0 ? void 0 : ref11.ctaText)) fullText.cta = item.cta;
            return fullText;
            break;
        case "shared.product-grid":
            var ref15, ref16, ref17, ref18, ref19, ref20;
            var ref21, ref22, ref23, ref24;
            var products = {
                id: item.id,
                type: "productsgrid",
                title: "rtest",
                limit: item.limit,
                sort: item.sort,
                exclude: item.exclude,
                collections: (ref22 = (ref17 = (ref15 = item.product_collections) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.data) === null || ref16 === void 0 ? void 0 : ref16.map(function(pdata) {
                    var ref;
                    return (ref21 = pdata === null || pdata === void 0 ? void 0 : (ref = pdata.attributes) === null || ref === void 0 ? void 0 : ref.medusa_id) !== null && ref21 !== void 0 ? ref21 : null;
                })) === null || ref17 === void 0 ? void 0 : ref17.filter(function(handle) {
                    return handle !== null;
                })) !== null && ref22 !== void 0 ? ref22 : [],
                products: (ref24 = (ref20 = (ref18 = item.products) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.data) === null || ref19 === void 0 ? void 0 : ref19.map(function(pdata) {
                    var ref;
                    return (ref23 = pdata === null || pdata === void 0 ? void 0 : (ref = pdata.attributes) === null || ref === void 0 ? void 0 : ref.medusa_id) !== null && ref23 !== void 0 ? ref23 : null;
                })) === null || ref20 === void 0 ? void 0 : ref20.filter(function(handle) {
                    return handle !== null;
                })) !== null && ref24 !== void 0 ? ref24 : []
            };
            return products;
            break;
        case "shared.slider":
            var ref25, ref26, ref27, ref28;
            var ref29, ref30, ref31;
            var slider = {
                id: item.id,
                type: "slider",
                title: (ref29 = item === null || item === void 0 ? void 0 : item.title) !== null && ref29 !== void 0 ? ref29 : "",
                products: (ref31 = (ref27 = (ref25 = item.products) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.data) === null || ref26 === void 0 ? void 0 : ref26.map(function(pdata) {
                    var ref;
                    return (ref30 = pdata === null || pdata === void 0 ? void 0 : (ref = pdata.attributes) === null || ref === void 0 ? void 0 : ref.medusa_id) !== null && ref30 !== void 0 ? ref30 : null;
                })) === null || ref27 === void 0 ? void 0 : ref27.filter(function(handle) {
                    return handle !== null;
                })) !== null && ref31 !== void 0 ? ref31 : []
            };
            if ((item === null || item === void 0 ? void 0 : item.cta) && (item === null || item === void 0 ? void 0 : (ref28 = item.cta) === null || ref28 === void 0 ? void 0 : ref28.ctaText)) slider.cta = item.cta;
            return slider;
            break;
        case "shared.usp-block":
            var uspBlock = {
                id: item.id,
                type: "uspblock",
                style: item.style
            };
            if (item === null || item === void 0 ? void 0 : item.items) uspBlock.items = item.items;
            return uspBlock;
    }
};
var parseImage = function(_image) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    if (!_image || typeof _image.data === "undefined") return undefined;
    var image = _image.data;
    var sizes = (image === null || image === void 0 ? void 0 : (ref = image.attributes) === null || ref === void 0 ? void 0 : ref.formats) || {};
    var response = {
        id: parseInt(image.id),
        name: image === null || image === void 0 ? void 0 : (ref1 = image.attributes) === null || ref1 === void 0 ? void 0 : ref1.name,
        width: image === null || image === void 0 ? void 0 : image.attributes.width,
        height: image === null || image === void 0 ? void 0 : image.attributes.height,
        url: image === null || image === void 0 ? void 0 : image.attributes.url,
        sizes: null
    };
    if (image === null || image === void 0 ? void 0 : (ref2 = image.attributes) === null || ref2 === void 0 ? void 0 : ref2.alternativeText) response.alternativeText = image === null || image === void 0 ? void 0 : (ref3 = image.attributes) === null || ref3 === void 0 ? void 0 : ref3.alternativeText;
    if (image === null || image === void 0 ? void 0 : (ref4 = image.attributes) === null || ref4 === void 0 ? void 0 : ref4.caption) response.caption = image === null || image === void 0 ? void 0 : (ref5 = image.attributes) === null || ref5 === void 0 ? void 0 : ref5.caption;
    if (Object.keys(sizes).length > 0) {
        response.sizes = Object.fromEntries(Object.entries(sizes).map(function(param, i) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                {
                    url: v === null || v === void 0 ? void 0 : v.url,
                    width: v === null || v === void 0 ? void 0 : v.width,
                    height: v === null || v === void 0 ? void 0 : v.height
                }
            ];
        }));
    }
    return response;
};


/***/ }),

/***/ 39594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_q": function() { return /* binding */ fetchProductsList; }
/* harmony export */ });
/* unused harmony exports getSiteData, getProductData, getCollectionData */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _lib_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17590);
/* provided dependency */ var process = __webpack_require__(34155);





var COL_LIMIT = 15;
var getFeaturedProducts = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var payload, products;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    payload = {};
                    if (process.env.FEATURED_PRODUCTS) {
                        payload.id = process.env.FEATURED_PRODUCTS;
                    } else {
                        payload.limit = 3;
                    }
                    return [
                        4,
                        _lib_config__WEBPACK_IMPORTED_MODULE_0__/* .medusaClient.products.list */ .pZ.products.list(payload).then(function(param) {
                            var products = param.products;
                            return products;
                        }).catch(function(_) {
                            return [];
                        })
                    ];
                case 1:
                    products = _state.sent();
                    return [
                        2,
                        products
                    ];
            }
        });
    });
    return function getFeaturedProducts() {
        return _ref.apply(this, arguments);
    };
}();
// get global data used in header and footer
var getGlobalData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var totalCount, collections, featuredProducts;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    totalCount = 0;
                    return [
                        4,
                        _lib_config__WEBPACK_IMPORTED_MODULE_0__/* .medusaClient.collections.list */ .pZ.collections.list({
                            limit: COL_LIMIT
                        }).then(function(param) {
                            var collections = param.collections, count = param.count;
                            totalCount = count;
                            return collections;
                        }).catch(function(_) {
                            return undefined;
                        })
                    ];
                case 1:
                    collections = _state.sent();
                    return [
                        4,
                        getFeaturedProducts()
                    ];
                case 2:
                    featuredProducts = _state.sent();
                    return [
                        2,
                        {
                            navData: {
                                hasMoreCollections: totalCount > COL_LIMIT,
                                collections: (collections === null || collections === void 0 ? void 0 : collections.map(function(c) {
                                    return {
                                        id: c.id,
                                        title: c.title
                                    };
                                })) || [],
                                featuredProducts: featuredProducts
                            }
                        }
                    ];
            }
        });
    });
    return function getGlobalData() {
        return _ref.apply(this, arguments);
    };
}();
var getSiteData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var globalData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getGlobalData()
                    ];
                case 1:
                    globalData = _state.sent();
                    return [
                        2,
                        {
                            site: globalData
                        }
                    ];
            }
        });
    });
    return function getSiteData() {
        return _ref.apply(this, arguments);
    };
}();
// get data for a specific product, as well as global data
var getProductData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(handle) {
        var data, product;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _lib_config__WEBPACK_IMPORTED_MODULE_0__/* .medusaClient.products.list */ .pZ.products.list({
                            handle: handle
                        }).then(function(param) {
                            var products = param.products;
                            return products;
                        })
                    ];
                case 1:
                    data = _state.sent();
                    product = data[0];
                    if (!product) {
                        throw new Error("Product with handle ".concat(handle, " not found"));
                    }
                    return [
                        2,
                        {
                            page: {
                                data: product
                            }
                        }
                    ];
            }
        });
    });
    return function getProductData(handle) {
        return _ref.apply(this, arguments);
    };
}();
var getInitialProducts = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(collectionId) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _lib_config__WEBPACK_IMPORTED_MODULE_0__/* .medusaClient.products.list */ .pZ.products.list({
                            collection_id: [
                                collectionId
                            ],
                            limit: 10
                        }).then(function(param) {
                            var products = param.products, count = param.count;
                            return {
                                initialProducts: products,
                                count: count,
                                hasMore: count > 10
                            };
                        }).catch(function(_) {
                            return {
                                initialProducts: [],
                                count: 0,
                                hasMore: false
                            };
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function getInitialProducts(collectionId) {
        return _ref.apply(this, arguments);
    };
}();
// get data for a specific collection, as well as global data
var getCollectionData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(id) {
        var siteData, data, additionalData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getGlobalData()
                    ];
                case 1:
                    siteData = _state.sent();
                    return [
                        4,
                        _lib_config__WEBPACK_IMPORTED_MODULE_0__/* .medusaClient.collections.retrieve */ .pZ.collections.retrieve(id).then(function(param) {
                            var collection = param.collection;
                            return collection;
                        }).catch(function() {
                            return undefined;
                        })
                    ];
                case 2:
                    data = _state.sent();
                    if (!data) {
                        throw new Error("Collection with handle ".concat(id, " not found"));
                    }
                    return [
                        4,
                        getInitialProducts(id)
                    ];
                case 3:
                    additionalData = _state.sent();
                    return [
                        2,
                        {
                            page: {
                                data: data,
                                additionalData: additionalData
                            },
                            site: siteData
                        }
                    ];
            }
        });
    });
    return function getCollectionData(id) {
        return _ref.apply(this, arguments);
    };
}();
var fetchProductsList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var _pageParam, pageParam, queryParams, whiteList, ref, listData, ref1, products, count, offset;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 0 : _pageParam, queryParams = param.queryParams;
                    whiteList = [];
                    // @ts-ignore
                    if (queryParams === null || queryParams === void 0 ? void 0 : queryParams.filters) {
                        ;
                        //get values and combine with whiteList
                        // @ts-ignore
                        whiteList = Object.values((ref = queryParams === null || queryParams === void 0 ? void 0 : queryParams.filters) !== null && ref !== void 0 ? ref : {}) // @ts-ignore
                        .reduce(function(o, n) {
                            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(o).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(n));
                        }, []) // @ts-ignore
                        .filter(function(value, index, array) {
                            return array.indexOf(value) === index;
                        });
                        // @ts-ignore
                        delete queryParams.filters;
                    }
                    listData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        limit: 12,
                        offset: pageParam
                    }, queryParams);
                    if (whiteList.length > 0) listData.id = whiteList;
                    return [
                        4,
                        _lib_config__WEBPACK_IMPORTED_MODULE_0__/* .medusaClient.products.list */ .pZ.products.list(listData)
                    ];
                case 1:
                    ref1 = _state.sent(), products = ref1.products, count = ref1.count, offset = ref1.offset;
                    return [
                        2,
                        {
                            response: {
                                products: products,
                                count: count
                            },
                            nextPage: count > offset + 12 ? offset + 12 : null
                        }
                    ];
            }
        });
    });
    return function fetchProductsList(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 46475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VR": function() { return /* binding */ getWebsiteItems; },
/* harmony export */   "yS": function() { return /* binding */ getSingleProductData; }
/* harmony export */ });
/* unused harmony exports getPosts, getSinglePost */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65253);




var parsePost = function(post) {
    var id = post.id, attributes = post.attributes;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var postData = {
        id: id,
        slug: (ref1 = (ref = attributes === null || attributes === void 0 ? void 0 : attributes.slug) !== null && ref !== void 0 ? ref : attributes === null || attributes === void 0 ? void 0 : attributes.Slug) !== null && ref1 !== void 0 ? ref1 : attributes === null || attributes === void 0 ? void 0 : attributes.handle,
        title: (ref3 = (ref2 = attributes === null || attributes === void 0 ? void 0 : attributes.title) !== null && ref2 !== void 0 ? ref2 : attributes === null || attributes === void 0 ? void 0 : attributes.Title) !== null && ref3 !== void 0 ? ref3 : "",
        updatedAt: (ref4 = attributes === null || attributes === void 0 ? void 0 : attributes.updatedAt) !== null && ref4 !== void 0 ? ref4 : new Date().toISOString(),
        publishedAt: (ref5 = attributes === null || attributes === void 0 ? void 0 : attributes.publishedAt) !== null && ref5 !== void 0 ? ref5 : new Date().toISOString(),
        createdAt: (ref6 = attributes === null || attributes === void 0 ? void 0 : attributes.createdAt) !== null && ref6 !== void 0 ? ref6 : new Date().toISOString()
    };
    if (attributes === null || attributes === void 0 ? void 0 : attributes.seo) {
        postData.seo = attributes.seo;
        postData.seo.metaImage = (0,_types__WEBPACK_IMPORTED_MODULE_0__/* .parseImage */ .e6)(attributes.seo.metaImage);
        if (postData.seo.metaSocial) {
            postData.seo.metaSocial = postData.seo.metaSocial.map(function(item) {
                return {
                    id: item.id,
                    socialNetwork: item.socialNetwork,
                    title: item.title,
                    description: item.description,
                    image: (0,_types__WEBPACK_IMPORTED_MODULE_0__/* .parseImage */ .e6)(item.image)
                };
            });
        }
    }
    if (attributes === null || attributes === void 0 ? void 0 : attributes.content) {
        postData.content = attributes.content.map(function(item) {
            return (0,_types__WEBPACK_IMPORTED_MODULE_0__/* .parseContent */ .nK)(item);
        });
    }
    if (attributes === null || attributes === void 0 ? void 0 : attributes.usps) {
        postData.usps = attributes === null || attributes === void 0 ? void 0 : attributes.usps;
    }
    return postData;
};
function getPosts() {
    return _getPosts.apply(this, arguments);
}
function _getPosts() {
    _getPosts = _async_to_generator(function() {
        var slug;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            slug = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "inspirations";
            //console.log(`${contentURL}api/${slug}?${shortPopulateString}`)
            return [
                2,
                fetch("".concat(contentURL, "api/").concat(slug, "?").concat(shortPopulateString)).then(function(res) {
                    return res.json();
                }).then(function(data) {
                    var ref;
                    return _object_spread({
                        posts: data === null || data === void 0 ? void 0 : data.data.map(function(post) {
                            return parsePost(post);
                        })
                    }, data === null || data === void 0 ? void 0 : (ref = data.meta) === null || ref === void 0 ? void 0 : ref.pagination);
                }).catch(function(err) {
                    console.error(err);
                    return {
                        posts: [],
                        page: 0,
                        pageSize: 0,
                        pageCount: 0,
                        total: 0
                    };
                })
            ];
        });
    });
    return _getPosts.apply(this, arguments);
}
function getSinglePost(postSlug) {
    return _getSinglePost.apply(this, arguments);
}
function _getSinglePost() {
    _getSinglePost = _async_to_generator(function(postSlug) {
        var slug;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            slug = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "inspirations";
            console.error("".concat(contentURL, "api/").concat(slug, "?filters[slug][$eq]=").concat(postSlug, "&").concat(populateString));
            return [
                2,
                fetch("".concat(contentURL, "api/").concat(slug, "?filters[slug][$eq]=").concat(postSlug, "&").concat(populateString)).then(function(res) {
                    return res.json();
                }).then(function(data) {
                    return parsePost(data === null || data === void 0 ? void 0 : data.data[0]);
                }).catch(function(err) {
                    console.log(err);
                    return null;
                })
            ];
        });
    });
    return _getSinglePost.apply(this, arguments);
}
function getWebsiteItems() {
    return _getWebsiteItems.apply(this, arguments);
}
function _getWebsiteItems() {
    _getWebsiteItems = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                fetch("".concat(_types__WEBPACK_IMPORTED_MODULE_0__/* .contentURL */ .lh, "api/website?populate[0]=items&populate[1]=desktopitems")).then(function(res) {
                    return res.json();
                }).then(function(data) {
                    var ref;
                    return data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.attributes;
                }).catch(function(err) {
                    console.log(err);
                    return null;
                })
            ];
        });
    });
    return _getWebsiteItems.apply(this, arguments);
}
function getSingleProductData(handle) {
    return _getSingleProductData.apply(this, arguments);
}
function _getSingleProductData() {
    _getSingleProductData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(handle) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            console.error("".concat(_types__WEBPACK_IMPORTED_MODULE_0__/* .contentURL */ .lh, "api/products?filters[handle][$eq]=").concat(handle, "&").concat(_types__WEBPACK_IMPORTED_MODULE_0__/* .populateString */ .qf));
            return [
                2,
                fetch("".concat(_types__WEBPACK_IMPORTED_MODULE_0__/* .contentURL */ .lh, "api/products?filters[handle][$eq]=").concat(handle, "&").concat(_types__WEBPACK_IMPORTED_MODULE_0__/* .populateString */ .qf)).then(function(res) {
                    return res.json();
                }).then(function(data) {
                    return parsePost(data === null || data === void 0 ? void 0 : data.data[0]);
                }).catch(function(err) {
                    console.log(err);
                    return null;
                })
            ];
        });
    });
    return _getSingleProductData.apply(this, arguments);
}


/***/ }),

/***/ 42984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_previews; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/lib/util/get-precentage-diff.ts
var get_precentage_diff = __webpack_require__(72702);
// EXTERNAL MODULE: ./node_modules/medusa-react/dist/medusa-react.esm.js + 1 modules
var medusa_react_esm = __webpack_require__(12863);
;// CONCATENATED MODULE: ./src/lib/util/transform-product-preview.ts


var transformProductPreview = function(product, region) {
    var ref, ref1, ref2, ref3;
    var variants = product.variants;
    var cheapestVariant = undefined;
    if ((variants === null || variants === void 0 ? void 0 : variants.length) > 0) {
        cheapestVariant = variants.reduce(function(acc, curr) {
            if (curr.prices.length > 0) {
                var ref;
                var ref1, ref2;
                curr.calculated_price = (ref2 = (ref1 = (ref = curr.prices.find(function(price) {
                    return price.price_list !== null;
                })) === null || ref === void 0 ? void 0 : ref.amount) !== null && ref1 !== void 0 ? ref1 : curr.prices.reduce(function(pacc, pcurr) {
                    return pacc.amount < pcurr.amount ? pacc : pcurr;
                }).amount) !== null && ref2 !== void 0 ? ref2 : curr.calculated_price;
            }
            if (acc.prices.length > 0) {
                var ref3;
                var ref4, ref5;
                acc.calculated_price = (ref5 = (ref4 = (ref3 = acc.prices.find(function(price) {
                    return price.price_list !== null;
                })) === null || ref3 === void 0 ? void 0 : ref3.amount) !== null && ref4 !== void 0 ? ref4 : acc.prices.reduce(function(pacc, pcurr) {
                    return pacc.amount < pcurr.amount ? pacc : pcurr;
                }).amount) !== null && ref5 !== void 0 ? ref5 : acc.calculated_price;
            }
            return acc.calculated_price > curr.calculated_price ? curr : acc;
        }, variants[0]);
    }
    var ref4;
    var calculatedPrice = (0,medusa_react_esm/* formatAmount */.dNj)({
        amount: (ref4 = cheapestVariant === null || cheapestVariant === void 0 ? void 0 : cheapestVariant.calculated_price) !== null && ref4 !== void 0 ? ref4 : 0,
        region: region,
        includeTaxes: false,
        locale: "nl-NL"
    });
    var ref5;
    var originalPrice = (0,medusa_react_esm/* formatAmount */.dNj)({
        amount: (ref5 = cheapestVariant === null || cheapestVariant === void 0 ? void 0 : cheapestVariant.original_price) !== null && ref5 !== void 0 ? ref5 : 0,
        region: region,
        includeTaxes: false,
        locale: "nl-NL"
    });
    var response = {
        id: product.id,
        title: product.title,
        handle: product.handle,
        thumbnail: product.thumbnail,
        secondThumbnail: (ref = product.images[1]) === null || ref === void 0 ? void 0 : ref.url,
        presale: !!((ref2 = product === null || product === void 0 ? void 0 : (ref1 = product.tags) === null || ref1 === void 0 ? void 0 : ref1.find(function(tag) {
            return (tag === null || tag === void 0 ? void 0 : tag.value) === "presale";
        })) === null || ref2 === void 0 ? void 0 : ref2.id),
        tags: product.tags.map(function(tag) {
            return tag.id;
        }),
        deliveryDate: product.deliveryDate,
        inStock: (product === null || product === void 0 ? void 0 : product.variants.length) > 1 && (product === null || product === void 0 ? void 0 : product.variants.reduce(function(acc, cur) {
            return (cur === null || cur === void 0 ? void 0 : cur.allow_backorder) ? 1 : Math.max(0, cur === null || cur === void 0 ? void 0 : cur.inventory_quantity);
        }, 0)) > 0 || (product === null || product === void 0 ? void 0 : product.variants[0].inventory_quantity) > 0,
        variant: (ref3 = variants[0]) === null || ref3 === void 0 ? void 0 : ref3.id,
        price: cheapestVariant ? {
            calculated_price: calculatedPrice.substring(calculatedPrice.length - 2) === "00" ? "".concat(calculatedPrice.substring(1, calculatedPrice.length - 2), "-") : calculatedPrice.substring(1, calculatedPrice.length),
            original_price: originalPrice.substring(originalPrice.length - 2) === "00" ? "".concat(originalPrice.substring(1, originalPrice.length - 2), "-") : originalPrice.substring(1, originalPrice.length),
            difference: (0,get_precentage_diff/* getPercentageDiff */.p)(cheapestVariant.original_price, cheapestVariant.calculated_price),
            price_type: cheapestVariant.calculated_price_type
        } : undefined
    };
    if (typeof (product === null || product === void 0 ? void 0 : product.reviews) !== "undefined") response.reviews = product.reviews;
    return response;
};
/* harmony default export */ var transform_product_preview = (transformProductPreview);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/lib/hooks/use-previews.tsx



var usePreviews = function(param) {
    var pages = param.pages, region = param.region;
    var previews = (0,react.useMemo)(function() {
        if (!pages || !region) {
            return [];
        }
        var products = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = pages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var page = _step.value;
                var _products;
                (_products = products).push.apply(_products, (0,_to_consumable_array/* default */.Z)(page.response.products));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var transformedProducts = products.map(function(p) {
            return transform_product_preview(p, region);
        });
        return transformedProducts;
    }, [
        pages,
        region
    ]);
    return previews;
};
/* harmony default export */ var use_previews = (usePreviews);


/***/ }),

/***/ 72702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ getPercentageDiff; }
/* harmony export */ });
var getPercentageDiff = function(original, calculated) {
    var diff = original - calculated;
    var decrease = diff / original * 100;
    return decrease.toFixed();
};


/***/ }),

/***/ 44269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ ImageLoader; }
/* harmony export */ });
var ImageLoader = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    src = src.replace("https://akupanelstore.ams3.digitaloceanspaces.com/", "").replace("https://ik.imagekit.io/ik8qpq4jb/", "").replace("https://ik.imagekit.io/mc4lho04c/", "").replace("ams3.digitaloceanspaces.com/akupanelstore/", "");
    if (src[0] === "/") src = src.slice(1);
    var params = [
        "width=".concat(Math.min(1920, width)),
        "format=webp",
        "lossless=true",
        "watermark=logo_long.png?format=png&watermark-alpha=10&watermark-position=center%2Cmiddle&watermark-scale=70"
    ];
    if (quality) params.push("q-".concat(quality));
    var paramsString = params.join("&");
    var urlEndpoint = "https://akupanelcdn.imglab-cdn.net";
    if (urlEndpoint[urlEndpoint.length - 1] === "/") urlEndpoint = urlEndpoint.substring(0, urlEndpoint.length - 1);
    return "".concat(urlEndpoint, "/").concat(src, "?").concat(paramsString);
};


/***/ }),

/***/ 61692:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var repeat = function(times) {
    return Array.from(Array(times).keys());
};
/* harmony default export */ __webpack_exports__["Z"] = (repeat);


/***/ }),

/***/ 37233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var ArrowRight = function(_param) {
    var _size = _param.size, size = _size === void 0 ? "20" : _size, _color = _param.color, color = _color === void 0 ? "currentColor" : _color, attributes = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, attributes), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.125 10H16.25",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.875 5L16.875 10L11.875 15",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowRight);


/***/ }),

/***/ 77092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_templates; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 3 modules
var listbox = __webpack_require__(38705);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(84539);
// EXTERNAL MODULE: ./src/lib/context/store-context.tsx + 1 modules
var store_context = __webpack_require__(40909);
// EXTERNAL MODULE: ./src/lib/hooks/use-toggle-state.tsx
var use_toggle_state = __webpack_require__(83721);
// EXTERNAL MODULE: ./node_modules/medusa-react/dist/medusa-react.esm.js + 1 modules
var medusa_react_esm = __webpack_require__(12863);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-country-flag/dist/react-country-flag.esm.js
var react_country_flag_esm = __webpack_require__(99318);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
;// CONCATENATED MODULE: ./src/modules/layout/components/country-select/index.tsx








var CountrySelect = function() {
    var ref = (0,store_context/* useStore */.o)(), countryCode = ref.countryCode, setRegion = ref.setRegion;
    var regions = (0,medusa_react_esm/* useRegions */.eHG)().regions;
    var ref1 = (0,react.useState)(undefined), current = ref1[0], setCurrent = ref1[1];
    var ref2 = (0,use_toggle_state/* default */.Z)(), state = ref2.state, open = ref2.open, close = ref2.close;
    var options = (0,react.useMemo)(function() {
        return regions === null || regions === void 0 ? void 0 : regions.map(function(r) {
            return r.countries.map(function(c) {
                return {
                    country: c.iso_2,
                    region: r.id,
                    label: c.display_name
                };
            });
        }).flat();
    }, [
        regions
    ]);
    (0,react.useEffect)(function() {
        if (countryCode) {
            var option = options === null || options === void 0 ? void 0 : options.find(function(o) {
                return o.country === countryCode;
            });
            setCurrent(option);
        }
    }, [
        countryCode,
        options
    ]);
    var handleChange = function(option) {
        setRegion(option.region, option.country);
        var currentCountry = options === null || options === void 0 ? void 0 : options.find(function(o) {
            return o.country === option.country;
        });
        setCurrent(currentCountry);
        close();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onMouseEnter: open,
        onMouseLeave: close,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox */.R, {
            onChange: handleChange,
            defaultValue: current,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Button */.R.Button, {
                    className: "py-1 w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-base-regular flex items-center gap-x-2 xsmall:justify-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    defaultMessage: "Verzenden naar:",
                                    id: "Ship to text"
                                })
                            }),
                            current && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-small-semi flex items-center gap-x-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_country_flag_esm/* default */.Z, {
                                        svg: true,
                                        style: {
                                            width: "16px",
                                            height: "16px"
                                        },
                                        alt: current.label,
                                        countryCode: current.country
                                    }),
                                    current.label
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative w-full min-w-[316px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        show: state,
                        as: react.Fragment,
                        leave: "transition ease-in duration-150",
                        leaveFrom: "opacity-100",
                        leaveTo: "opacity-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
                            className: "absolute -bottom-[calc(100%-36px)] left-0 max-h-[442px] overflow-y-scroll z-[900] bg-white drop-shadow-md text-small-regular uppercase text-black no-scrollbar min-w-[150px]",
                            static: true,
                            children: options === null || options === void 0 ? void 0 : options.map(function(o) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox.Option */.R.Option, {
                                    value: o,
                                    className: "py-2 hover:bg-gray-200 px-3 cursor-pointer flex items-center gap-x-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_country_flag_esm/* default */.Z, {
                                            svg: true,
                                            style: {
                                                width: "16px",
                                                height: "16px"
                                            },
                                            alt: o.label,
                                            countryCode: o.country
                                        }),
                                        " ",
                                        o.label
                                    ]
                                }, o.country);
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var country_select = (CountrySelect);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/modules/common/icons/spinner.tsx
var spinner = __webpack_require__(18000);
// EXTERNAL MODULE: ./src/modules/common/components/button/index.tsx
var components_button = __webpack_require__(77391);
// EXTERNAL MODULE: ./src/modules/common/components/input/index.tsx + 2 modules
var input = __webpack_require__(1166);
// EXTERNAL MODULE: ./src/lib/config.ts
var config = __webpack_require__(17590);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
;// CONCATENATED MODULE: ./src/modules/layout/components/footer-cta/index.tsx












var isValidEmail = function(email) {
    return(// eslint-disable-next-line no-useless-escape
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email));
};
var FooterCTA = function() {
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), submitting = ref[0], setSubmitting = ref[1];
    var ref1 = (0,react.useState)(undefined), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(undefined), success = ref2[0], setSuccess = ref2[1];
    var ref3 = (0,index_esm/* useForm */.cI)(), register = ref3.register, handleSubmit = ref3.handleSubmit, errors = ref3.formState.errors, reset = ref3.reset;
    var submit = handleSubmit(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var payload, url;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setSubmitting(true);
                setError(undefined);
                payload = {
                    email_address: data.email,
                    status: "subscribed"
                };
                url = "".concat(config/* MEDUSA_BACKEND_URL */.n1, "store/newsletter");
                fetch(url, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                }).then(function(response) {
                    return response.json();
                }).then(function(data) {
                    //console.log(data)
                    if (data.error === null || data.error.length < 1) {
                        reset({
                            email: ""
                        });
                        setSuccess(intl.formatMessage({
                            id: "newsletter-success",
                            defaultMessage: "Je bent ingeschreven voor onze nieuwsbrief! Controleer uw e-mail voor een bevestiging."
                        }));
                        setSubmitting(false);
                    } else setError(data.error);
                    setSubmitting(false);
                }).catch(function(error) {
                    console.error(error);
                    setError(intl.formatMessage({
                        id: "newsletter-error",
                        defaultMessage: "Er is iets misgegaan. Probeer het later opnieuw."
                    }));
                    setSubmitting(false);
                });
                return [
                    2
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-lg lg:text-2xl font-sans font-semibold",
                children: "Blijf op de hoogte"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: submit,
                className: "mt-6 max-w-[500px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-md",
                        children: "Schrijf je in voor onze nieuwsbrief en blijf up-to-date met de laatste akupanelen trends."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex flex-row mt-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                label: "Email"
                            }, register("email", {
                                required: intl.formatMessage({
                                    id: "email-required",
                                    defaultMessage: "Email is verplicht"
                                }),
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: intl.formatMessage({
                                        id: "email-invalid",
                                        defaultMessage: "Ongeldig e-mailadres"
                                    })
                                }
                            })), {
                                required: true,
                                errors: errors,
                                autoComplete: "email-address",
                                mainClassName: "w-full bg-white text-darkTone",
                                "aria-label": "Email address"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_button/* default */.Z, {
                                className: "min-h-0 w-[100px] min-h-[46px] bg-accent border-accent",
                                type: "submit",
                                "aria-label": "Aanmelden",
                                disabled: submitting,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "nieuwsbrief-button",
                                        defaultMessage: "Aanmelden"
                                    }),
                                    submitting && /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* default */.Z, {})
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-rose-500 text-small-regular py-2 font-mono",
                        children: error
                    }),
                    success && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-green-500 text-base-regular py-2 font-mono",
                        children: success
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var footer_cta = (FooterCTA);

// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/gr/index.esm.js
var gr_index_esm = __webpack_require__(45155);
// EXTERNAL MODULE: ./node_modules/react-icons/si/index.esm.js
var si_index_esm = __webpack_require__(97735);
;// CONCATENATED MODULE: ./src/modules/layout/components/footer-nav/index.tsx








var FooterNav = function() {
    var year = new Date().getFullYear();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "content-container flex flex-col gap-y-8 pt-16 pb-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-y-6 xsmall:flex-row items-start justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full small:w-auto flex flex-col justify-center small:justify-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_cta, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-base-regular grid grid-cols-1 md:grid-cols-3 gap-y-8 md:gap-y-0 gap-x-16 lg:ml-10 2xl:ml-40",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-y-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-lg lg:text-xl font-sans font-semibold border-b border-neutral-800 pb-2 mb-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "over-aku-title",
                                            defaultMessage: "Over Akupanel Store"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "grid grid-cols-1 gap-y-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/samenwerken",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "samenwerken",
                                                        defaultMessage: "Samenwerken"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/inspiratie",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "Blog",
                                                        defaultMessage: "Blog"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/zakelijk",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "zakelijk",
                                                        defaultMessage: "Zakelijke klanten"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(country_select, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-y-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-lg lg:text-xl font-sans font-semibold border-b border-neutral-800 pb-2 mb-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "klantenservice",
                                            defaultMessage: "Klantenservice"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "grid grid-cols-1 gap-y-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "text-green-500",
                                                children: [
                                                    "Maandag 12.00 - 17.00",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "Dinsdag 09.00 - 17.00",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "Woensdag 09.00 - 15.00",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "Donderdag 09.00 - 17.00"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/contact",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "contact",
                                                        defaultMessage: "Contact"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/verzend-retourbeleid",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "verzend-retourbeleid",
                                                        defaultMessage: "Verzend en retourbeleid"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/veelgestelde-vragen",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "veelgestelde-vragen",
                                                        defaultMessage: "Veelgestelde vragen"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-y-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-lg lg:text-xl font-sans font-semibold border-b border-neutral-800 pb-2 mb-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "adres",
                                            defaultMessage: "Adresgegevens"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "gap-y-2",
                                        children: [
                                            "Verdunplein 17",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                className: "text-gray-400",
                                                children: "(Geen showroom adres!)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "5627 SZ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "Eindhoven",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:team@akupanel-store.nl",
                                                children: "team@akupanel-store.nl"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row flex-wrap gap-y-4 gap-x-4 w-full text-xs md:text-lg align-center"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col-reverse gap-y-4 justify-center xsmall:items-center xsmall:flex-row xsmall:items-end xsmall:justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "text-small-regular text-neutral-500 whitespace-nowrap",
                        children: [
                            "\xa9 Copyright 2022 - ",
                            year,
                            " AkuPanel Store."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full md:min-w-[316px] xsmall:justify-end gap-x-6 flex flex-wrap flex-row text-neutral-700",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                viewBox: "0 0 200 130",
                                width: "2.8rem",
                                className: "fill-neutral-700",
                                height: "2.8rem",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "m200 122.9v-2.9c0-.4-.3-.6-.8-.6h-1.9c-.6 0-.9-.1-1.1-.3-.1-.2-.2-.7-.2-1.5v-11.1h3.1c.2 0 .4-.1.5-.2.2-.2.2-.3.2-.5v-3.1c0-.2-.1-.4-.2-.5-.2-.2-.3-.2-.5-.2h-3.1v-4c0-.2-.1-.4-.2-.5s-.3-.2-.5-.2h-.1l-4.6.8c-.2.1-.4.1-.5.3-.2.1-.2.3-.2.5v3.1h-3c-.2 0-.4.1-.6.2-.2.2-.2.3-.2.6v2.5c0 .2.1.4.2.5.2.1.3.2.6.3l3 .5v11.1c0 1.3.1 2.4.4 3.3s.7 1.5 1.2 2 1.2.8 2 1 1.7.2 2.7.2c.6 0 1.1 0 1.5-.1s.9-.1 1.5-.2c.6-.3.8-.5.8-1m-16.4-.4v-3.4c0-.2-.1-.4-.2-.5s-.3-.2-.5-.2h-.1c-.7.1-1.4.1-2 .2s-1.5.1-2.6.1c-.4 0-.8-.1-1.2-.2s-.7-.4-1-.7-.5-.8-.7-1.4-.2-1.3-.2-2.1v-3.2c0-.8.1-1.5.2-2.1.2-.6.4-1 .7-1.4.3-.3.6-.6 1-.7s.8-.2 1.2-.2c1.1 0 2 0 2.6.1s1.3.1 2 .2h.1c.2 0 .4-.1.5-.2s.2-.3.2-.5v-3.4c0-.3-.1-.5-.2-.6s-.3-.2-.6-.3c-.5-.1-1.2-.3-2.1-.4s-1.8-.2-3-.2c-2.7 0-4.8.8-6.5 2.5s-2.4 4-2.4 7.2v3.2c0 3.1.8 5.5 2.4 7.2s3.8 2.5 6.5 2.5c1.1 0 2.1-.1 3-.2s1.5-.3 2.1-.4c.3-.1.5-.2.6-.3s.2-.3.2-.6m-24.8-4c-.5.2-.9.4-1.5.6-.5.2-1.1.2-1.7.2-.8 0-1.4-.1-1.8-.3s-.6-.7-.6-1.6v-.3c0-.5.1-.9.2-1.2.1-.4.3-.6.5-.9.3-.2.6-.4 1-.5s1-.2 1.6-.2h2.2zm6-9.2c0-1.4-.2-2.6-.6-3.6s-1-1.8-1.8-2.4-1.7-1.1-2.8-1.4-2.3-.4-3.7-.4c-1.3 0-2.5.1-3.7.3s-2.2.4-2.9.5c-.5.1-.7.4-.7.8v3.1c0 .3.1.4.2.5s.3.2.5.2h.2c.3 0 .7-.1 1.1-.1.5 0 1-.1 1.5-.1.6 0 1.2 0 1.8-.1h1.8c.9 0 1.6.2 2.1.5s.8 1 .8 2.1v1.4h-2.1c-3.3 0-5.7.5-7.1 1.5-1.5 1-2.2 2.7-2.2 4.9v.3c0 1.2.2 2.3.6 3.1s.9 1.5 1.5 2 1.3.9 2.1 1.1 1.6.3 2.4.3c1.1 0 2.1-.2 3-.5.8-.3 1.6-.7 2.3-1.3v.6c0 .2.1.4.2.5.2.2.3.2.5.2h4.3c.2 0 .4-.1.5-.2.2-.2.2-.3.2-.5zm-20.3 13.6v-2.9c0-.4-.3-.6-.8-.6h-1.9c-.6 0-.9-.1-1.1-.3-.1-.2-.2-.7-.2-1.5v-11.1h3.1c.2 0 .4-.1.5-.2s.2-.3.2-.5v-3.1c0-.2-.1-.4-.2-.5s-.3-.2-.5-.2h-3.1v-4c0-.2-.1-.4-.2-.5s-.3-.2-.5-.2h-.1l-4.6.8c-.2.1-.4.1-.5.3-.2.1-.2.3-.2.5v3.1h-3c-.2 0-.4.1-.6.2-.2.2-.2.3-.2.6v2.5c0 .2.1.4.2.5.2.1.3.2.6.3l3 .5v11.1c0 1.3.1 2.4.4 3.3s.7 1.5 1.2 2 1.2.8 2 1 1.7.2 2.7.2c.6 0 1.1 0 1.5-.1s.9-.1 1.5-.2c.5-.3.8-.5.8-1m-16.6-.1v-12.7c0-1.2-.1-2.3-.3-3.4s-.5-2-1-2.7c-.5-.8-1.2-1.4-2.1-1.8-.9-.5-2-.7-3.4-.7-1.2 0-2.3.1-3.2.4s-1.9.8-3 1.6v-.9c0-.2-.1-.4-.2-.5-.2-.2-.3-.2-.5-.2h-4.3c-.2 0-.4.1-.5.2-.2.2-.2.3-.2.5v20.3c0 .2.1.4.2.6.2.2.3.2.6.2h4.6c.2 0 .4-.1.5-.2.2-.2.2-.3.2-.6v-15c.7-.4 1.3-.6 1.9-.9.6-.2 1.2-.3 1.7-.3.6 0 1.1.1 1.4.2.4.1.7.3.9.6s.3.6.4 1.1.1 1 .1 1.7v12.7c0 .2.1.4.2.6.2.2.3.2.5.2h4.6c.2 0 .4-.1.6-.2.2-.4.3-.6.3-.8m-28.9-8.7c0 3.1-1.1 4.7-3.4 4.7-1.1 0-2-.4-2.5-1.2-.6-.8-.9-2-.9-3.5v-2.7c0-1.5.3-2.7.9-3.5s1.4-1.2 2.5-1.2c2.2 0 3.4 1.6 3.4 4.6zm6.2-2.7c0-1.5-.2-2.9-.6-4.1s-1-2.3-1.8-3.1c-.8-.9-1.8-1.5-3-2s-2.6-.7-4.1-.7c-1.6 0-2.9.2-4.1.7s-2.2 1.1-3 2-1.4 1.9-1.9 3.1c-.4 1.2-.6 2.6-.6 4.1v2.7c0 1.5.2 2.9.6 4.1s1 2.3 1.9 3.1c.8.9 1.8 1.5 3 2s2.6.7 4.1.7c1.6 0 2.9-.2 4.1-.7s2.2-1.1 3-2 1.4-1.9 1.8-3.1.6-2.6.6-4.1zm-21.2 11.1v-3.4c0-.2-.1-.4-.2-.5s-.3-.2-.5-.2h-.1c-.7.1-1.4.1-2 .2s-1.5.1-2.6.1c-.4 0-.8-.1-1.2-.2s-.7-.4-1-.7-.5-.8-.7-1.4-.2-1.3-.2-2.1v-3.2c0-.8.1-1.5.2-2.1.2-.6.4-1 .7-1.4.3-.3.6-.6 1-.7s.8-.2 1.2-.2c1.1 0 2 0 2.6.1s1.3.1 2 .2h.1c.2 0 .4-.1.5-.2s.2-.3.2-.5v-3.4c0-.3-.1-.5-.2-.6s-.3-.2-.6-.3c-.5-.1-1.2-.3-2.1-.4s-1.8-.2-3-.2c-2.7 0-4.8.8-6.5 2.5-1.6 1.7-2.4 4-2.4 7.2v3.2c0 3.1.8 5.5 2.4 7.2s3.8 2.5 6.5 2.5c1.1 0 2.1-.1 3-.2s1.5-.3 2.1-.4c.3-.1.5-.2.6-.3.2-.1.2-.3.2-.6m-18.7.3v-12.7c0-1.2-.1-2.3-.3-3.4s-.5-2-1-2.7c-.5-.8-1.2-1.4-2.1-1.8-.9-.5-2-.7-3.4-.7-1.2 0-2.3.1-3.2.4s-1.9.8-3 1.6v-.9c0-.2-.1-.4-.2-.5-.2-.2-.3-.2-.5-.2h-4.3c-.2 0-.4.1-.5.2-.2.2-.2.3-.2.5v20.3c0 .2.1.4.2.6.2.2.3.2.6.2h4.6c.2 0 .4-.1.5-.2.2-.2.2-.3.2-.6v-15c.7-.4 1.3-.6 1.9-.9.6-.2 1.2-.3 1.7-.3.6 0 1.1.1 1.4.2.4.1.7.3.9.6s.3.6.4 1.1.1 1 .1 1.7v12.7c0 .2.1.4.2.6.2.2.3.2.5.2h4.6c.2 0 .4-.1.6-.2.2-.4.3-.6.3-.8m-29.4-4.3c-.5.2-.9.4-1.5.6-.5.2-1.1.2-1.7.2-.8 0-1.4-.1-1.8-.3s-.6-.7-.6-1.6v-.3c0-.5.1-.9.2-1.2.1-.4.3-.6.5-.9.3-.2.6-.4 1-.5s1-.2 1.6-.2h2.2c.1 0 .1 4.2.1 4.2zm6.1-9.2c0-1.4-.2-2.6-.6-3.6s-1-1.8-1.8-2.4-1.7-1.1-2.8-1.4-2.3-.4-3.7-.4c-1.3 0-2.5.1-3.7.3s-2.2.4-2.9.5c-.5.1-.7.4-.7.8v3.1c0 .3.1.4.2.5s.3.2.5.2h.2c.3 0 .7-.1 1.1-.1.5 0 1-.1 1.5-.1.6 0 1.2 0 1.8-.1h1.8c.9 0 1.6.2 2.1.5s.8 1 .8 2.1v1.4h-2.1c-3.3 0-5.7.5-7.1 1.5-1.5 1-2.2 2.7-2.2 4.9v.3c0 1.2.2 2.3.6 3.1s.9 1.5 1.5 2 1.3.9 2.1 1.1 1.6.3 2.4.3c1.1 0 2.1-.2 3-.5s1.6-.7 2.3-1.3v.6c0 .2.1.4.2.5.2.2.3.2.5.2h4.3c.2 0 .4-.1.5-.2.2-.2.2-.3.2-.5zm-27.3 6c0 1.1-.4 1.9-1.1 2.5s-2.1.9-4.1.9h-.6c-.3 0-.6 0-.9 0s-.6 0-.9 0h-.7v-7.1h4.3c1.5 0 2.6.3 3.2 1s.9 1.5.9 2.4c-.1-.1-.1.3-.1.3zm-.1-11.4c0 .4-.1.8-.2 1.2s-.3.7-.6 1-.7.5-1.2.6c-.5.2-1.1.2-1.9.2h-4.3v-6.6h.6.8.8.6c2 0 3.3.2 4.1.7s1.2 1.3 1.2 2.3v.6zm6.5 11c0-1.3-.3-2.5-.9-3.4-.6-1-1.4-1.7-2.5-2.2 1-.5 1.8-1.3 2.4-2.2.6-1 .8-2.1.8-3.4v-.7c0-1.5-.3-2.8-.9-3.8s-1.4-1.8-2.5-2.4-2.3-1-3.8-1.3-3.1-.4-4.9-.4c-.6 0-1.2 0-1.9 0s-1.3.1-1.9.1-1.2.1-1.7.1c-.5.1-.9.1-1.3.2-.7.1-1.3.4-1.6.7-.2.2-.4.8-.4 1.7v23.2c0 .9.2 1.5.5 1.8s.9.6 1.6.7c.4.1.8.1 1.4.2.5.1 1.1.1 1.7.1s1.3.1 1.9.1h1.9c1.7 0 3.2-.1 4.7-.4s2.7-.7 3.8-1.4c1.1-.6 1.9-1.5 2.6-2.6.6-1.1 1-2.5 1-4.2z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "m175 21.6h-57.2l-35.2 40.2h-64.4l18.6-20.7h-8.6-12-6.8c-5.1 0-9.4 4.3-9.4 9.6v18.5 1.7c0 5.3 4.2 9.6 9.4 9.6h2.6 94.9 7c5.1 0 12.2-3.2 15.6-7.1l16.3-18.5z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "m190.6 0h-104.3c-5.1 0-12.2 3.2-15.6 7.1l-45.7 51.8h55.8l35.6-40.1h65.2l-18.1 20.6h27.1c5.1 0 9.4-4.3 9.4-9.6v-20.2c0-5.3-4.2-9.6-9.4-9.6z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                id: "sofort_logo",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 800 264",
                                width: "3.1rem",
                                className: "fill-neutral-700",
                                height: "3.1rem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    transform: "matrix(0.54981622,0,0,0.54981622,271.3869,-35.870245)",
                                    id: "icons--sofortueberweisung",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "path442",
                                            d: "m 625.292,167.605 c -7.41,20.141 -20.712,32.601 -46.018,32.601 h -0.094 l -13.093,-0.021 22.378,-60.951 h 12.733 c 23.296,0.016 31.996,6.89 24.094,28.371 m 67.155,-55.678 C 681.069,95.374 657.904,87.245 621.621,87.21 h -84 l -90.857,252.033 h 77.179 l 33.024,-88.717 c 1.612,3.639 21.104,88.717 21.104,88.717 h 81.123 c 0,0 -14.754,-62.517 -25.606,-87.769 -2.793,-6.482 -5.7,-13.765 -9.581,-19.834 22.913,-8.604 56.115,-27.062 69.86,-64.49 8.454,-23.004 7.961,-41.574 -1.42,-55.223 M -83.01,87.063 h -143.074 c -22.562,0 -44.463,0 -64.102,10.055 -19.636,10.07 -36.959,30.211 -50.306,70.482 -2.892,8.669 -4.426,16.125 -4.619,22.592 -0.199,6.513 0.914,12.027 3.345,16.829 3.002,5.844 7.869,11.365 13.954,16.012 6.09,4.633 13.386,8.425 21.242,10.84 0.308,0.081 4.434,1.275 9.433,2.707 a 1555.423,1555.423 0 0 1 14.509,4.311 c 2.156,0.667 4.541,1.535 6.697,2.839 2.153,1.29 4.079,3.022 5.3,5.438 a 12.426,12.426 0 0 1 1.274,5.209 c 0.051,1.875 -0.261,3.898 -0.997,6.023 -1.827,5.484 -4.604,8.991 -9.889,11.162 -5.273,2.14 -13.057,2.842 -24.847,2.94 h -147.233 l -23.28,64.574 h 157.604 c 14.82,0 41.935,0 67.987,-11.181 26.053,-11.181 51.042,-33.528 61.617,-78.239 3.985,-16.812 2.759,-30.49 -3.77,-41.245 -6.528,-10.763 -18.364,-18.545 -35.569,-23.54 0,0 -3.853,-1.13 -8.386,-2.45 -4.525,-1.306 -9.734,-2.81 -12.409,-3.589 -4.406,-1.274 -7.787,-3.854 -9.79,-7.134 -1.996,-3.267 -2.6,-7.248 -1.458,-11.315 1.175,-4.208 4.033,-7.587 8.161,-9.906 4.149,-2.314 9.597,-3.589 15.949,-3.589 h 91.606 c 0.638,-0.953 1.223,-1.961 1.875,-2.909 16.738,-23.908 36.992,-43.253 59.176,-56.916"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "path444",
                                            d: "m -15.805,211.911 c -21.379,59.109 -36.905,73.994 -60.264,73.994 h -0.045 c -22.761,-0.035 -30.739,-14.575 -9.437,-73.402 15.896,-43.925 36.5,-72.022 61.408,-72.022 h 0.016 c 23.703,0.036 29.135,13.904 8.322,71.43 M 57.569,110.674 C 45.096,92.658 23.763,83.495 -5.926,83.465 c -19.43,0 -38.278,4.505 -55.96,12.93 -25.267,12.078 -48.183,32.239 -66.892,58.989 -12.142,17.369 -22.538,37.479 -30.7,59.99 -15.363,42.488 -15.182,76.965 0.522,99.684 8.914,12.833 27.403,28.179 65.029,28.208 h 0.146 c 68.543,0 119.73,-45.377 152.133,-134.878 8.554,-23.7 19.852,-67.886 -0.783,-97.714 M 331.489,87.063 H 185.676 c -40.763,0 -71.104,20.829 -85.44,59.825 L 30.979,339.075 h 75.87 l 35.585,-98.807 67.054,0.055 19.068,-52.909 -66.831,-0.046 10.756,-30.64 c 2.256,-5.483 7.609,-9.856 15.46,-9.856 4.362,0 53.573,0.015 79.057,0.031 0.652,-0.948 1.24,-1.977 1.893,-2.925 16.726,-23.907 40.413,-43.252 62.598,-56.915 m 66.319,124.848 c -21.364,59.109 -36.891,73.994 -60.249,73.994 h -0.049 c -22.772,-0.035 -30.72,-14.575 -9.433,-73.402 15.88,-43.925 36.497,-72.022 61.405,-72.022 h 0.033 c 23.688,0.036 29.121,13.904 8.293,71.43 m 73.39,-101.237 C 458.709,92.658 437.391,83.495 407.682,83.465 c -19.409,0 -38.258,4.505 -55.925,12.93 -25.282,12.078 -48.184,32.239 -66.907,58.989 -12.16,17.369 -22.544,37.479 -30.7,59.99 -15.365,42.488 -15.182,76.965 0.538,99.684 8.89,12.833 27.388,28.179 65.044,28.208 h 0.1 c 68.573,0 119.761,-45.377 152.132,-134.878 8.585,-23.7 19.868,-67.886 -0.766,-97.714"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "path440",
                                            d: "m 695.906,87.206 c 4.88,3.903 9.092,8.352 12.604,13.449 8.962,13.062 12.404,28.596 10.365,46.392 h 45.949 l -69.277,192.239 h 69.211 l 69.294,-192.239 h 88.902 L 944.52,87.207 H 695.906 Z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            id: "path446",
                                            d: "m -350.432,377.589 c -1.633,4.505 -3.674,7.67 -6.105,9.47 -2.432,1.808 -6.105,2.711 -11.016,2.711 -4.91,0 -7.917,-0.867 -8.977,-2.615 -1.065,-1.732 -0.803,-4.78 0.767,-9.173 1.667,-4.586 3.67,-7.757 6.07,-9.531 2.4,-1.763 6.059,-2.659 10.97,-2.659 4.915,0 7.917,0.862 9.028,2.563 1.11,1.711 0.866,4.78 -0.737,9.234 m -41.838,0 c -1.628,4.505 -3.636,7.67 -6.052,9.47 -2.4,1.808 -6.059,2.711 -10.969,2.711 -4.931,0 -7.917,-0.867 -9.013,-2.615 -1.106,-1.732 -0.862,-4.78 0.721,-9.173 1.649,-4.586 3.69,-7.757 6.105,-9.531 2.416,-1.763 6.069,-2.659 10.916,-2.659 4.98,0 8.017,0.862 9.082,2.563 1.074,1.711 0.812,4.78 -0.79,9.234 m 22.416,101.728 c -2.763,7.669 -6.368,14.528 -10.794,20.584 -4.403,6.074 -9.527,11.196 -15.388,15.375 -5.846,4.199 -12.359,7.379 -19.524,9.581 -7.181,2.187 -14.904,3.277 -23.196,3.277 -7.788,0 -14.431,-0.974 -19.914,-2.951 -5.486,-1.957 -9.645,-4.944 -12.489,-8.943 -2.823,-4.002 -4.291,-8.96 -4.421,-14.938 -0.115,-5.952 1.274,-12.924 4.143,-20.925 l 27.427,-76.1 c 0.244,-0.651 0.635,-1.222 1.205,-1.742 0.558,-0.505 1.404,-0.933 2.515,-1.258 1.096,-0.312 2.484,-0.576 4.148,-0.766 1.664,-0.198 3.735,-0.301 6.235,-0.301 2.434,0 4.406,0.103 5.925,0.301 1.519,0.189 2.709,0.454 3.56,0.766 0.828,0.325 1.371,0.753 1.595,1.258 0.229,0.521 0.229,1.091 0,1.742 l -26.62,73.866 c -1.793,4.976 -2.744,9.287 -2.839,12.91 -0.099,3.659 0.553,6.661 1.957,9.046 1.419,2.399 3.476,4.179 6.2,5.365 2.729,1.194 6.044,1.795 9.942,1.795 3.95,0 7.724,-0.616 11.281,-1.845 a 33.37,33.37 0 0 0 9.89,-5.371 c 3.006,-2.35 5.73,-5.24 8.164,-8.7 2.415,-3.445 4.423,-7.359 6.006,-11.752 l 27.13,-75.314 c 0.247,-0.651 0.637,-1.222 1.205,-1.742 0.576,-0.505 1.388,-0.933 2.464,-1.258 1.081,-0.312 2.469,-0.576 4.163,-0.766 1.682,-0.198 3.754,-0.301 6.169,-0.301 2.431,0 4.396,0.103 5.896,0.301 1.483,0.189 2.657,0.454 3.491,0.766 0.852,0.325 1.358,0.753 1.552,1.258 0.199,0.521 0.199,1.091 -0.048,1.742 z m 108.513,-43.62 c 0.897,-2.518 1.32,-4.75 1.271,-6.758 -0.035,-2.013 -0.588,-3.654 -1.648,-4.979 -1.061,-1.319 -2.615,-2.334 -4.687,-3.054 -2.087,-0.701 -5.058,-1.06 -8.959,-1.06 h -12.735 l -11.699,32.479 h 14.068 c 3.639,0 6.691,-0.424 9.176,-1.305 2.495,-0.866 4.716,-2.054 6.689,-3.572 a 24.63,24.63 0 0 0 5.14,-5.306 27.512,27.512 0 0 0 3.384,-6.445 m -12.896,53.572 c 1.027,-2.904 1.504,-5.483 1.351,-7.786 -0.13,-2.283 -0.844,-4.194 -2.118,-5.745 -1.304,-1.548 -3.236,-2.745 -5.815,-3.576 -2.576,-0.852 -6.151,-1.254 -10.738,-1.254 h -14.937 l -12.812,35.566 h 18.184 c 3.511,0 6.58,-0.355 9.243,-1.096 a 27.378,27.378 0 0 0 7.425,-3.298 c 2.265,-1.452 4.288,-3.26 6.069,-5.416 1.763,-2.156 3.137,-4.616 4.148,-7.395 m 26.442,-0.865 c -1.603,4.438 -3.659,8.469 -6.19,12.098 -2.51,3.589 -5.333,6.788 -8.469,9.565 a 56.37,56.37 0 0 1 -10.234,7.151 66.332,66.332 0 0 1 -11.589,4.922 75.339,75.339 0 0 1 -12.473,2.859 c -4.258,0.621 -8.894,0.917 -13.872,0.917 h -32.926 c -2.106,0 -3.656,-0.621 -4.653,-1.896 -0.975,-1.244 -0.945,-3.281 0.066,-6.136 l 39.308,-109.071 c 1.027,-2.828 2.48,-4.867 4.372,-6.142 1.895,-1.253 3.889,-1.876 5.991,-1.876 h 31.113 c 7.588,0 13.793,0.637 18.589,1.927 4.801,1.289 8.539,3.231 11.2,5.861 2.662,2.593 4.227,5.906 4.701,9.906 0.492,4.002 -0.244,8.7 -2.201,14.117 a 41.812,41.812 0 0 1 -4.249,8.558 42.258,42.258 0 0 1 -5.954,7.293 44.058,44.058 0 0 1 -7.509,5.814 c -2.745,1.681 -5.683,3.018 -8.782,4.046 3.267,0.652 6.09,1.779 8.491,3.395 2.38,1.621 4.21,3.69 5.499,6.238 1.289,2.548 1.958,5.529 2.006,8.944 0.035,3.415 -0.701,7.248 -2.235,11.51 m 92.59,27.561 c -0.667,1.859 -1.32,3.43 -1.926,4.683 -0.62,1.259 -1.211,2.268 -1.825,3.033 -0.591,0.789 -1.195,1.345 -1.801,1.701 -0.599,0.361 -1.19,0.54 -1.774,0.54 h -62.229 c -2.087,0 -3.636,-0.637 -4.617,-1.896 -0.997,-1.258 -0.981,-3.296 0.045,-6.135 l 39.308,-109.072 c 1.012,-2.844 2.484,-4.883 4.357,-6.137 1.893,-1.258 3.904,-1.896 6.007,-1.896 h 61.835 c 0.584,0 1.027,0.179 1.351,0.49 0.347,0.325 0.507,0.901 0.561,1.681 0.031,0.815 -0.117,1.859 -0.408,3.099 -0.297,1.274 -0.787,2.859 -1.488,4.786 -0.652,1.813 -1.29,3.348 -1.894,4.606 -0.622,1.249 -1.205,2.263 -1.812,3.047 -0.606,0.771 -1.189,1.327 -1.763,1.683 -0.569,0.356 -1.144,0.54 -1.733,0.54 h -44.218 l -11,30.553 h 37.428 c 0.576,0 1.029,0.184 1.388,0.524 0.344,0.358 0.553,0.917 0.606,1.646 0.046,0.754 -0.084,1.748 -0.376,3.008 -0.298,1.259 -0.752,2.776 -1.405,4.586 -0.688,1.875 -1.325,3.41 -1.926,4.639 -0.588,1.223 -1.178,2.216 -1.779,2.95 -0.573,0.738 -1.174,1.273 -1.764,1.605 -0.606,0.321 -1.174,0.488 -1.763,0.488 h -37.412 l -12.717,35.286 h 44.597 c 0.583,0 1.043,0.18 1.404,0.526 0.344,0.356 0.537,0.912 0.568,1.691 0.051,0.77 -0.079,1.8 -0.377,3.052 -0.304,1.246 -0.78,2.827 -1.448,4.693 m 118.103,-78.24 c 1.485,-4.112 1.83,-7.609 0.996,-10.433 -0.831,-2.839 -3.152,-4.831 -6.951,-6.003 -1.144,-0.326 -2.5,-0.571 -4.067,-0.771 -1.549,-0.192 -3.771,-0.291 -6.643,-0.291 h -11.298 l -12.779,35.486 h 12.833 c 3.576,0 6.836,-0.423 9.841,-1.304 3.002,-0.867 5.665,-2.096 8.016,-3.675 a 24.64,24.64 0 0 0 6.07,-5.667 c 1.678,-2.184 3.005,-4.631 3.982,-7.342 m 1.862,84.901 c -0.263,0.717 -0.606,1.319 -1.029,1.793 -0.429,0.475 -1.175,0.882 -2.253,1.212 -1.075,0.322 -2.549,0.551 -4.457,0.684 -1.896,0.113 -4.437,0.179 -7.642,0.179 -2.671,0 -4.795,-0.065 -6.345,-0.179 -1.535,-0.133 -2.709,-0.377 -3.511,-0.738 -0.801,-0.342 -1.291,-0.811 -1.484,-1.351 -0.183,-0.54 -0.244,-1.207 -0.229,-1.979 L -63.219,494.3 c -0.214,-3.165 -0.504,-5.974 -0.897,-8.42 -0.408,-2.451 -1.095,-4.49 -2.041,-6.135 -0.981,-1.651 -2.352,-2.874 -4.079,-3.711 -1.733,-0.846 -3.968,-1.27 -6.628,-1.27 h -7.854 l -17.185,47.661 c -0.232,0.657 -0.652,1.244 -1.244,1.748 -0.604,0.52 -1.434,0.928 -2.514,1.26 -1.061,0.325 -2.432,0.585 -4.113,0.779 -1.664,0.184 -3.735,0.28 -6.22,0.28 -2.431,0 -4.42,-0.097 -5.971,-0.28 -1.569,-0.194 -2.759,-0.454 -3.595,-0.779 -0.862,-0.332 -1.369,-0.74 -1.564,-1.26 -0.194,-0.504 -0.179,-1.091 0.051,-1.748 l 40.937,-113.611 c 1.027,-2.839 2.481,-4.878 4.377,-6.137 1.873,-1.253 3.884,-1.891 5.986,-1.891 h 32.078 c 3.247,0 5.907,0.082 7.964,0.21 a 89.78,89.78 0 0 1 5.567,0.478 c 4.734,0.699 8.764,1.942 12.129,3.67 3.361,1.743 5.922,4.016 7.688,6.825 1.764,2.808 2.692,6.119 2.791,9.941 0.079,3.849 -0.782,8.241 -2.561,13.199 -1.519,4.215 -3.415,8.017 -5.716,11.479 a 48.672,48.672 0 0 1 -7.963,9.225 c -3.022,2.709 -6.383,5.06 -10.108,7.067 -3.72,1.992 -7.718,3.609 -11.997,4.83 a 16.657,16.657 0 0 1 4.033,3.283 c 1.175,1.29 2.138,2.854 2.907,4.7 0.783,1.828 1.387,3.933 1.81,6.267 0.422,2.371 0.716,5.03 0.866,8.002 l 1.549,24.646 c 0.063,2.432 0.063,4.226 -0.031,5.351 -0.083,1.132 -0.243,2.028 -0.473,2.667 m 156.549,-3.192 c -0.928,1.556 -1.912,2.792 -2.938,3.727 -0.996,0.927 -2.255,1.645 -3.774,2.119 -1.518,0.494 -3.361,0.815 -5.514,0.979 -2.157,0.169 -4.88,0.245 -8.126,0.245 -3.644,0 -6.534,-0.076 -8.669,-0.245 -2.14,-0.163 -3.773,-0.484 -4.869,-0.979 -1.106,-0.475 -1.779,-1.192 -2.018,-2.119 -0.23,-0.935 -0.23,-2.171 0,-3.727 l 8.76,-79.278 H 93.97 l -47.34,79.278 c -0.851,1.488 -1.733,2.711 -2.645,3.623 -0.915,0.953 -2.087,1.667 -3.506,2.171 -1.442,0.525 -3.251,0.867 -5.455,1.03 -2.187,0.169 -5.046,0.245 -8.552,0.245 -3.69,0 -6.627,-0.076 -8.768,-0.245 -2.151,-0.163 -3.769,-0.484 -4.864,-0.979 -1.106,-0.475 -1.779,-1.192 -2.003,-2.119 -0.244,-0.935 -0.283,-2.171 -0.099,-3.727 L 21.93,410.281 c 0.265,-2.329 0.588,-4.163 1.012,-5.467 0.413,-1.321 1.129,-2.345 2.21,-3.054 1.042,-0.698 2.509,-1.141 4.388,-1.304 1.862,-0.159 4.441,-0.246 7.688,-0.246 3.004,0 5.354,0.046 7.086,0.147 1.712,0.099 2.954,0.327 3.736,0.668 0.751,0.378 1.175,0.882 1.258,1.57 0.084,0.668 -0.015,1.615 -0.262,2.839 l -12.814,95.821 h 0.114 l 56.873,-95.154 c 0.683,-1.202 1.387,-2.217 2.087,-2.981 0.688,-0.769 1.603,-1.376 2.745,-1.783 1.144,-0.424 2.593,-0.718 4.388,-0.881 1.782,-0.159 4.097,-0.246 6.975,-0.246 3.067,0 5.484,0.066 7.262,0.199 1.776,0.133 3.071,0.408 3.915,0.815 0.835,0.423 1.327,1.028 1.503,1.794 0.164,0.77 0.148,1.809 -0.066,3.083 l -10.918,95.154 h 0.199 l 56.146,-95.546 c 0.56,-1.01 1.128,-1.891 1.732,-2.646 0.571,-0.728 1.388,-1.319 2.434,-1.727 1.042,-0.424 2.431,-0.718 4.148,-0.881 1.712,-0.159 4.06,-0.246 7.081,-0.246 2.793,0 4.949,0.087 6.467,0.246 1.496,0.163 2.478,0.605 2.938,1.304 0.421,0.709 0.354,1.764 -0.232,3.155 -0.604,1.371 -1.616,3.262 -3.052,5.646 z m 129.844,-3.469 a 50.994,50.994 0 0 1 -1.923,4.683 c -0.622,1.259 -1.213,2.268 -1.833,3.033 -0.586,0.789 -1.19,1.345 -1.797,1.701 -0.599,0.361 -1.189,0.54 -1.778,0.54 h -62.221 c -2.09,0 -3.639,-0.637 -4.635,-1.896 -0.981,-1.258 -0.966,-3.296 0.063,-6.135 l 39.306,-109.072 c 1.011,-2.844 2.484,-4.883 4.357,-6.137 1.896,-1.258 3.904,-1.896 6.006,-1.896 h 61.836 c 0.586,0 1.029,0.179 1.353,0.49 0.344,0.325 0.52,0.901 0.558,1.681 0.016,0.815 -0.114,1.859 -0.413,3.099 -0.292,1.274 -0.782,2.859 -1.483,4.786 a 41.888,41.888 0 0 1 -1.909,4.606 c -0.591,1.249 -1.189,2.263 -1.796,3.047 -0.604,0.771 -1.195,1.327 -1.764,1.683 -0.567,0.356 -1.159,0.54 -1.732,0.54 H 237.13 l -11.016,30.553 h 37.428 c 0.591,0 1.03,0.184 1.404,0.524 0.344,0.358 0.538,0.917 0.591,1.646 0.062,0.754 -0.069,1.748 -0.361,3.008 -0.296,1.259 -0.751,2.776 -1.404,4.586 -0.688,1.875 -1.325,3.41 -1.924,4.639 -0.606,1.223 -1.195,2.216 -1.782,2.95 -0.588,0.738 -1.156,1.273 -1.763,1.605 -0.604,0.321 -1.19,0.488 -1.764,0.488 h -37.427 l -12.718,35.286 h 44.598 c 0.583,0 1.042,0.18 1.404,0.526 0.339,0.356 0.538,0.912 0.583,1.691 0.054,0.77 -0.079,1.8 -0.374,3.052 -0.292,1.246 -0.784,2.827 -1.452,4.693 m 53.402,6.471 c -0.23,0.652 -0.638,1.229 -1.244,1.748 -0.604,0.504 -1.435,0.927 -2.515,1.238 -1.075,0.327 -2.431,0.587 -4.11,0.785 -1.667,0.194 -3.738,0.296 -6.217,0.296 -2.431,0 -4.424,-0.102 -5.976,-0.296 -1.564,-0.198 -2.759,-0.458 -3.605,-0.785 -0.852,-0.312 -1.389,-0.734 -1.604,-1.238 -0.244,-0.52 -0.229,-1.096 0,-1.748 l 42.575,-118.169 c 0.239,-0.632 0.652,-1.219 1.253,-1.728 0.604,-0.52 1.472,-0.928 2.562,-1.253 1.111,-0.332 2.484,-0.592 4.164,-0.786 1.666,-0.182 3.707,-0.29 6.138,-0.29 2.479,0 4.488,0.108 6.021,0.29 1.52,0.194 2.709,0.454 3.545,0.786 0.851,0.325 1.389,0.733 1.618,1.253 0.224,0.509 0.224,1.096 -0.021,1.728 z m 122.602,-34.032 c -2.386,6.578 -5.683,12.342 -9.877,17.307 -4.228,4.979 -8.992,9.106 -14.347,12.42 -5.341,3.327 -11.103,5.83 -17.253,7.506 a 71.247,71.247 0 0 1 -18.709,2.498 c -4.273,0 -8.126,-0.361 -11.538,-1.06 -3.414,-0.704 -6.353,-1.551 -8.798,-2.548 -2.435,-1.011 -4.406,-2.055 -5.892,-3.15 -1.488,-1.091 -2.518,-2.06 -3.022,-2.906 -0.522,-0.83 -0.7,-2.038 -0.472,-3.623 0.209,-1.584 0.847,-3.852 1.927,-6.824 0.716,-1.992 1.383,-3.673 2.005,-5.014 0.619,-1.365 1.226,-2.462 1.814,-3.293 0.587,-0.852 1.175,-1.441 1.797,-1.778 0.599,-0.361 1.221,-0.546 1.857,-0.546 0.896,0 1.962,0.546 3.213,1.59 1.243,1.075 2.908,2.254 5,3.543 2.089,1.274 4.719,2.461 7.866,3.521 3.151,1.064 7.071,1.604 11.721,1.604 3.068,0 5.938,-0.376 8.637,-1.13 2.708,-0.734 5.124,-1.779 7.31,-3.135 a 22.674,22.674 0 0 0 5.678,-5.025 23.005,23.005 0 0 0 3.759,-6.677 c 1.029,-2.844 1.126,-5.254 0.323,-7.292 -0.797,-2.044 -2.135,-3.842 -4.028,-5.407 -1.893,-1.601 -4.148,-3.067 -6.758,-4.46 a 329.115,329.115 0 0 1 -8.101,-4.402 53.843,53.843 0 0 1 -7.765,-5.274 22.938,22.938 0 0 1 -5.845,-7.054 c -1.471,-2.737 -2.286,-5.973 -2.485,-9.724 -0.175,-3.727 0.673,-8.211 2.568,-13.435 2.151,-5.993 5.14,-11.263 8.994,-15.818 3.834,-4.542 8.161,-8.308 12.978,-11.3 4.811,-3 10.019,-5.238 15.635,-6.722 a 65.698,65.698 0 0 1 16.93,-2.221 c 2.938,0 5.777,0.229 8.567,0.673 2.778,0.452 5.287,1.06 7.572,1.844 2.256,0.765 4.213,1.631 5.847,2.61 1.633,0.963 2.66,1.764 3.053,2.399 0.407,0.652 0.637,1.208 0.697,1.662 0.069,0.442 0.039,1.05 -0.061,1.777 -0.1,0.755 -0.329,1.683 -0.686,2.81 a 95.127,95.127 0 0 1 -1.404,4.215 c -0.688,1.859 -1.31,3.444 -1.862,4.714 -0.574,1.304 -1.096,2.369 -1.618,3.199 -0.535,0.837 -1.072,1.458 -1.634,1.85 a 3.258,3.258 0 0 1 -1.872,0.566 c -0.704,0 -1.665,-0.438 -2.875,-1.335 -1.189,-0.912 -2.724,-1.896 -4.587,-2.956 -1.842,-1.08 -4.082,-2.038 -6.706,-2.905 -2.614,-0.881 -5.683,-1.305 -9.191,-1.305 -2.744,0 -5.274,0.343 -7.54,1.016 -2.301,0.683 -4.342,1.61 -6.137,2.803 -1.796,1.191 -3.35,2.628 -4.604,4.306 a 19.087,19.087 0 0 0 -2.938,5.326 c -0.997,2.762 -1.111,5.172 -0.344,7.194 0.767,2.023 2.117,3.839 4.082,5.423 1.939,1.565 4.258,3.054 6.967,4.44 a 281.633,281.633 0 0 1 8.162,4.393 61.19,61.19 0 0 1 7.884,5.27 c 2.479,1.977 4.472,4.326 5.976,7.068 1.503,2.742 2.334,5.958 2.548,9.662 0.191,3.706 -0.621,8.085 -2.418,13.11 m 131.776,-9.087 c -2.777,7.669 -6.368,14.528 -10.771,20.584 -4.426,6.074 -9.551,11.196 -15.411,15.375 -5.846,4.199 -12.341,7.379 -19.521,9.581 -7.181,2.187 -14.904,3.277 -23.213,3.277 -7.77,0 -14.413,-0.974 -19.899,-2.951 -5.483,-1.957 -9.645,-4.944 -12.489,-8.943 -2.823,-4.002 -4.303,-8.96 -4.402,-14.938 -0.131,-5.952 1.256,-12.924 4.128,-20.925 l 27.423,-76.1 c 0.23,-0.651 0.622,-1.222 1.206,-1.742 0.573,-0.505 1.403,-0.933 2.499,-1.258 1.111,-0.312 2.5,-0.576 4.164,-0.766 1.682,-0.198 3.753,-0.301 6.237,-0.301 2.432,0 4.404,0.103 5.923,0.301 1.518,0.189 2.708,0.454 3.56,0.766 0.83,0.325 1.365,0.753 1.58,1.258 0.247,0.521 0.247,1.091 0,1.742 l -26.604,73.866 c -1.796,4.976 -2.744,9.287 -2.843,12.91 -0.095,3.659 0.558,6.661 1.961,9.046 1.404,2.399 3.477,4.179 6.2,5.365 2.729,1.194 6.042,1.795 9.94,1.795 3.935,0 7.708,-0.616 11.283,-1.845 a 33.468,33.468 0 0 0 9.89,-5.371 c 3.021,-2.35 5.746,-5.24 8.162,-8.7 2.415,-3.445 4.426,-7.359 6.006,-11.752 l 27.148,-75.314 c 0.229,-0.651 0.621,-1.222 1.189,-1.742 0.573,-0.505 1.389,-0.933 2.462,-1.258 1.08,-0.312 2.469,-0.576 4.165,-0.766 1.695,-0.198 3.752,-0.301 6.167,-0.301 2.434,0 4.396,0.103 5.899,0.301 1.48,0.189 2.655,0.454 3.49,0.766 0.852,0.325 1.356,0.753 1.551,1.258 0.213,0.521 0.197,1.091 -0.031,1.742 z m 124.18,37.702 c -0.538,1.487 -1.256,2.808 -2.202,3.965 a 13.971,13.971 0 0 1 -3.088,2.894 11.78,11.78 0 0 1 -3.67,1.693 c -1.324,0.361 -2.563,0.54 -3.789,0.54 h -10.722 c -2.235,0 -4.083,-0.23 -5.551,-0.683 a 7.067,7.067 0 0 1 -3.61,-2.468 c -0.943,-1.177 -1.68,-2.787 -2.232,-4.83 -0.538,-2.023 -1.03,-4.654 -1.457,-7.869 l -9.758,-58.516 a 216.693,216.693 0 0 1 -1.388,-11.248 149.118,149.118 0 0 1 -0.736,-11.757 h -0.194 a 587.058,587.058 0 0 1 -4.424,13.877 684.144,684.144 0 0 1 -4.964,14.271 l -23.588,65.457 c -0.225,0.637 -0.617,1.218 -1.145,1.742 -0.535,0.504 -1.305,0.933 -2.301,1.289 -0.977,0.357 -2.247,0.638 -3.766,0.831 -1.552,0.199 -3.477,0.296 -5.777,0.296 -2.225,0 -4.036,-0.097 -5.44,-0.296 -1.386,-0.193 -2.445,-0.474 -3.151,-0.831 -0.699,-0.356 -1.106,-0.785 -1.252,-1.289 -0.13,-0.524 -0.084,-1.105 0.146,-1.742 l 40.528,-112.456 c 1.096,-3.033 2.777,-5.306 5.079,-6.825 2.301,-1.498 4.747,-2.262 7.295,-2.262 h 13.5 c 2.416,0 4.389,0.194 5.892,0.617 1.503,0.422 2.744,1.125 3.705,2.089 0.951,0.963 1.697,2.304 2.239,4.015 0.523,1.698 0.946,3.803 1.26,6.337 l 7.634,45.719 c 0.413,2.776 0.818,5.498 1.226,8.179 0.408,2.675 0.783,5.353 1.091,8.032 0.313,2.66 0.606,5.285 0.882,7.883 0.299,2.565 0.543,5.139 0.767,7.718 h 0.084 c 1.435,-4.5 2.984,-9.204 4.65,-14.117 a 992.265,992.265 0 0 1 4.916,-14.006 l 21.157,-58.699 c 0.229,-0.652 0.634,-1.224 1.205,-1.748 0.558,-0.504 1.355,-0.958 2.4,-1.351 1.042,-0.377 2.316,-0.651 3.835,-0.82 1.534,-0.163 3.445,-0.244 5.746,-0.244 2.155,0 3.95,0.081 5.354,0.244 1.42,0.169 2.449,0.443 3.102,0.82 0.667,0.393 1.058,0.847 1.19,1.351 0.149,0.524 0.081,1.096 -0.148,1.748 z m 170.311,-96.791 c -0.668,1.883 -1.331,3.478 -1.993,4.833 -0.642,1.351 -1.259,2.451 -1.814,3.246 -0.591,0.806 -1.142,1.371 -1.682,1.701 -0.535,0.307 -1.08,0.47 -1.646,0.47 -0.835,0 -1.957,-0.586 -3.408,-1.742 -1.422,-1.143 -3.436,-2.401 -5.994,-3.773 -2.578,-1.335 -5.794,-2.607 -9.602,-3.771 -3.832,-1.161 -8.551,-1.728 -14.18,-1.728 a 49.317,49.317 0 0 0 -17.399,3.135 c -5.601,2.09 -10.81,5.057 -15.655,8.893 -4.835,3.833 -9.144,8.456 -12.912,13.827 -3.789,5.386 -6.872,11.328 -9.222,17.837 -2.576,7.165 -3.903,13.47 -3.98,18.922 -0.084,5.433 0.912,10.004 2.969,13.663 2.056,3.686 5.124,6.448 9.207,8.329 4.079,1.869 8.989,2.808 14.735,2.808 2.792,0 5.715,-0.332 8.689,-0.969 a 43.055,43.055 0 0 0 8.699,-2.904 l 10.442,-29.009 h -23.453 c -1.142,0 -1.778,-0.714 -1.894,-2.187 -0.13,-1.447 0.454,-3.898 1.713,-7.395 0.652,-1.794 1.271,-3.313 1.878,-4.536 0.588,-1.237 1.19,-2.206 1.763,-2.956 0.606,-0.732 1.176,-1.288 1.748,-1.631 0.571,-0.356 1.16,-0.54 1.728,-0.54 h 41.841 c 1.01,0 1.855,0.184 2.527,0.54 0.669,0.343 1.173,0.862 1.535,1.586 0.356,0.718 0.504,1.564 0.453,2.559 -0.03,0.998 -0.275,2.14 -0.733,3.444 l -17.949,49.786 c -0.693,1.941 -1.651,3.644 -2.826,5.076 -1.211,1.452 -2.992,2.595 -5.376,3.444 -2.362,0.831 -5.255,1.698 -8.632,2.61 a 141.156,141.156 0 0 1 -10.363,2.318 127.042,127.042 0 0 1 -10.48,1.442 c -3.46,0.321 -6.888,0.49 -10.284,0.49 -9.889,0 -18.234,-1.443 -25.008,-4.298 -6.79,-2.889 -11.915,-7.033 -15.375,-12.471 -3.461,-5.447 -5.209,-12.093 -5.26,-19.931 -0.049,-7.833 1.718,-16.717 5.29,-26.639 3.689,-10.253 8.539,-19.443 14.529,-27.602 6.006,-8.165 12.843,-15.086 20.516,-20.8 7.692,-5.706 16.03,-10.069 25.073,-13.103 9.047,-3.021 18.429,-4.54 28.206,-4.54 5.356,0 10.106,0.377 14.234,1.127 4.133,0.733 7.654,1.635 10.564,2.691 2.905,1.06 5.219,2.221 6.951,3.429 1.712,1.243 2.854,2.288 3.395,3.201 0.54,0.896 0.703,2.171 0.488,3.815 -0.213,1.658 -0.896,4.088 -2.053,7.303"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                id: "giropay_logo",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 885.8 380.9",
                                width: "2.7rem",
                                height: "2.7rem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#404040",
                                            id: "_92653320",
                                            d: "M0 68.3C0 30.6 30.8 0 68.7 0h748.5c37.9 0 68.7 30.6 68.7 68.3v244.2c0 37.7-30.7 68.3-68.7 68.3H68.7C30.8 380.9 0 350.3 0 312.6V68.3z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#262221",
                                            id: "_92186184",
                                            d: "M28.2 70.7v239.6c0 23.6 19.2 42.7 42.9 42.7h392.1V28H71.1c-23.7 0-42.9 19.1-42.9 42.7zm536.4 118.6c0 15.3-7.5 25.7-20 25.7-11 0-20.2-10.5-20.2-24.5 0-14.3 8.1-25 20.2-25 12.8.1 20 11.1 20 23.8zm-73.4 87.5h33.1v-52h.4c6.3 11.4 18.8 15.6 30.3 15.6 28.5 0 43.7-23.5 43.7-51.8 0-23.2-14.5-48.3-41-48.3-15.1 0-29 6.1-35.7 19.5h-.4v-17.3h-30.5v134.3zm152.7-69c0-9.2 8.8-12.7 20-12.7 5 0 9.7.3 14 .5 0 11.2-7.9 22.6-20.4 22.6-7.7.1-13.6-3.7-13.6-10.4zm66.8 30.4c-1.5-7.5-1.8-15.1-1.8-22.6v-35.7c0-29.2-21.1-39.7-45.6-39.7-14.1 0-26.5 2-38.2 6.8l.6 22.4c9.2-5.2 19.8-7.2 30.5-7.2 11.9 0 21.7 3.5 21.9 16.6-4.2-.7-10.1-1.3-15.4-1.3-17.6 0-49.4 3.5-49.4 32.7 0 20.8 16.9 30.1 35.8 30.1 13.6 0 22.8-5.3 30.3-17.3h.4c0 5 .5 9.9.7 15.1h30.2zm14.8 38.6c6.8 1.5 13.6 2.2 20.6 2.2 30.3 0 37.5-23.4 46.9-47.4l35.1-89.1H795L775.3 205h-.3l-20.6-62.5h-35.6l38.8 98c-2.4 8.5-8.6 13.2-16.7 13.2-4.6 0-8.6-.6-13.1-2l-2.3 25.1z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#404040",
                                            id: "_47303032",
                                            d: "M109 189.5c0-13.1 6.4-23.9 18.8-23.9 14.9 0 21.1 11.9 21.1 22.6 0 14.7-9.4 24.6-21.1 24.6-10 0-18.8-8.4-18.8-23.3zm71.9-47.1h-30v17.3h-.3c-7-11.8-18.4-19.5-32.5-19.5-29.8 0-43.2 21.3-43.2 49.8 0 28.3 16.4 48.2 42.6 48.2 13.3 0 24.3-5.2 32.2-16.4h.4v5.2c0 18.7-10.3 27.7-29.4 27.7-13.8 0-22.3-2.9-32.4-7.9l-1.7 26.1c7.7 2.8 20.8 6.1 36.6 6.1 38.6 0 57.7-12.7 57.7-52v-84.6zm55.9-39.9h-33.1v24.3h33.1v-24.3zm-33.1 135.7h33.1v-95.8h-33.1v95.8zm125.2-96.9c-3.3-.5-7.4-1.1-11.2-1.1-14.3 0-22.6 7.7-28.3 19.9h-.4v-17.6h-30.1v95.8H292v-40.4c0-18.8 8.7-30 24.1-30 3.9 0 7.5 0 11.2 1.1l1.6-27.7zm57 75.9c-15.3 0-21.5-12.7-21.5-26.8 0-14.3 6.2-27 21.5-27s21.5 12.7 21.5 27c0 14.1-6.3 26.8-21.5 26.8zm0 23.2c31.6 0 55.7-18.4 55.7-50 0-31.8-24.1-50.2-55.7-50.2s-55.7 18.4-55.7 50.2c0 31.6 24 50 55.7 50z"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                version: "1.1",
                                id: "eps_logo",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "2.7rem",
                                height: "2.7rem",
                                className: "fill-neutral-700",
                                viewBox: "0 0 889 577",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M663,295L663,295h-61.252c-6.813,0-12.355-5.428-12.355-12.223 c0-6.795,5.543-12.777,12.355-12.777H695v-46h-93.252c-32.547,0-59.028,26.534-59.028,59s26.481,59,59.028,59h60.42 c6.813,0,12.356,5.406,12.356,12.201S668.98,366,662.168,366H532.605c-11,21-21.695,39-43.408,48H663 c32-0.461,58.176-27.542,58.176-59.721C721.176,322.102,695,295.461,663,295"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M428.197,224C376.283,224,334,266.535,334,318.8v2V516h47V414h47.099 c51.915,0,94.049-43.101,94.049-95.366C522.147,266.369,480.113,224,428.197,224 M428.197,366H381v-47.366 c0-26.468,21.073-48.002,47.197-48.002c26.125,0,47.377,21.534,47.377,48.002C475.574,345.103,454.322,366,428.197,366"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M185.203,414c-44.44,0-81.802-31.667-91.912-73.037 c0,0-2.921-13.678-2.921-22.685s2.765-22.826,2.765-22.826c10.183-41.268,47.499-71.998,91.866-71.998 c52.181,0,94.999,42.418,94.999,94.598V341H141.365c8.187,16,24.744,25,43.838,25h124.626L310,230.681 c0-20.175-16.505-36.681-36.68-36.681H96.682C76.507,194,60,210.006,60,230.181v176.638C60,426.994,76.507,444,96.682,444h176.638 c18.105,0,33.208-13,36.126-30H185.203z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M185,268.356c-19.02,0-35.561,11.644-43.781,26.644h87.564 C220.563,280,204.023,268.356,185,268.356"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M265,136.559c0-43.111-35.828-78.059-80.023-78.059 c-43.463,0-78.812,33.805-79.973,75.928c-0.019,0.178-0.004,0.351-0.004,0.534v23.458c0,2.806,2.285,5.58,5.161,5.58h29.441 c2.876,0,5.398-2.774,5.398-5.58v-21.861c0-21.528,17.93-39.043,40-39.043s40,17.515,40,39.043v21.861 c0,2.806,2.333,5.58,5.209,5.58h29.442c2.876,0,5.349-2.774,5.349-5.58V136.559z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M480.928,475.001l-4.256,24.098c-2.128,12.18-10.109,17.758-20.927,17.758 c-9.162,0-16.256-5.972-14.187-17.738l4.255-24.117h6.563l-4.258,24.098c-1.301,7.511,2.069,11.787,8.454,11.787 c6.562,0,12.178-3.903,13.536-11.768l4.257-24.117H480.928z M455.153,467.455c0,2.01,1.538,2.954,3.193,2.954 c2.069,0,4.316-1.477,4.316-4.255c0-1.95-1.303-2.954-3.017-2.954C457.52,463.2,455.153,464.559,455.153,467.455 M469.342,467.396 c0,2.068,1.596,3.013,3.311,3.013c1.832,0,4.257-1.477,4.257-4.195c0-1.949-1.421-3.014-3.016-3.014 C471.766,463.2,469.342,464.559,469.342,467.396"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M496.787,475l-2.956,16.651c2.541-3.427,7.625-5.238,11.172-5.238 c7.33,0,12.414,4.295,12.414,12.273c0,11.291-7.862,18.081-17.91,18.081c-3.902,0-7.214-1.45-9.223-5.114L489.161,516h-5.734 l7.271-41H496.787z M492.177,503.102c-0.236,4.847,2.896,7.98,7.447,7.98c5.734,0,11.29-4.436,11.646-11.172 c0.236-4.907-2.955-7.805-7.391-7.805C498.204,492.105,492.529,496.658,492.177,503.102"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M529.371,504c-0.237,4,2.896,7.266,8.217,7.266 c2.956,0,6.856-1.155,8.984-3.165l3.311,3.826c-3.604,3.309-8.926,4.955-13.418,4.955c-8.393,0-13.301-5.026-13.301-12.712 c0-10.227,8.039-17.848,18.324-17.848c9.4,0,14.721,5.678,11.528,17.678H529.371z M548.051,499c0.473-5-2.482-7.035-7.39-7.035 c-4.433,0-8.511,2.035-10.286,7.035H548.051z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M569.283,487l-0.297,3.855c2.84-3.729,6.268-4.488,9.399-4.488 c2.837,0,5.378,1.007,6.739,2.483l-3.664,5.321c-1.301-1.179-2.602-1.77-4.849-1.77c-4.197,0-8.334,2.517-9.28,7.896L564.555,516 h-6.09l5.143-29H569.283z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            points: "614.455,487 617.528,509.934 628.642,487 635.439,487 620.188,516 613.036,516 610.14,496.869 605.469,506.373 600.386,516 593.292,516 588.148,487 595.006,487 598.021,509.934 609.193,487 "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M643.259,504c-0.237,4,2.896,7.266,8.217,7.266 c2.956,0,6.856-1.155,8.983-3.165l3.312,3.826c-3.604,3.309-8.926,4.955-13.418,4.955c-8.394,0-13.301-5.026-13.301-12.712 c0-10.227,8.039-17.848,18.325-17.848c9.399,0,14.72,5.678,11.527,17.678H643.259z M661.938,499c0.473-5-2.482-7.035-7.39-7.035 c-4.432,0-8.511,2.035-10.286,7.035H661.938z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M683.585,487l-5.142,29h-6.09l5.144-29H683.585z M678.206,479.1 c0,2.068,1.538,3.137,3.193,3.137c2.364,0,4.552-1.54,4.552-4.435c0-1.953-1.479-3.077-3.074-3.077 C680.688,474.725,678.206,476.146,678.206,479.1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M710.605,494.174c-1.893-2.128-4.314-2.719-7.211-2.719 c-4.022,0-6.858,1.36-6.858,3.901c0,2.128,2.305,3.018,5.734,3.312c5.32,0.472,12.118,2.247,10.699,9.754 c-1.004,5.438-6.443,8.63-14.011,8.63c-4.728,0-9.28-1.065-12.354-5.379l3.96-4.315c2.187,3.013,6.03,4.256,9.458,4.315 c2.896,0,6.326-1.064,6.857-3.783c0.532-2.601-1.773-3.605-6.029-4.021c-4.966-0.473-10.403-2.303-10.403-7.802 c0-7.271,7.86-9.813,13.773-9.813c4.491,0,7.803,1.004,10.522,3.901L710.605,494.174z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M729.824,487l-2.776,15.617c-0.887,4.967,1.36,8.398,6.442,8.398 c4.788,0,8.867-3.967,9.693-8.813l2.66-15.202h6.089l-5.141,29h-5.498l0.413-4.202c-3.429,3.251-6.799,4.784-10.876,4.784 c-7.153,0-11.409-5.128-9.873-13.933L723.736,487H729.824z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M778.665,516l2.778-15.522c0.886-5.025-0.826-8.354-6.384-8.354 c-4.847,0-8.928,3.899-9.754,8.687L762.645,516h-6.088l5.145-29h5.555l-0.413,4.238c3.37-3.133,6.856-4.679,10.638-4.679 c7.096,0,11.707,4.936,10.112,13.863L784.813,516H778.665z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M799.303,520c-0.413,4,2.66,5.618,7.806,5.618 c4.493,0,9.341-2.509,10.464-8.892l0.885-4.98c-2.659,3.724-7.507,5.194-11.111,5.194c-7.45,0-12.651-4.436-12.651-12.478 c0-11.466,8.511-18.089,18.146-18.089c4.081,0,7.746,1.938,9.047,5.248l1.006-4.622h5.91l-5.085,29.862 c-1.89,11.056-10.107,14.486-17.614,14.486c-8.987,0-13.95-4.349-12.711-11.349H799.303z M801.018,503.28 c0,4.963,3.252,7.979,7.925,7.979c12.588,0,15.959-19.33,3.366-19.33C806.338,491.93,801.018,496.361,801.018,503.28"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(si_index_esm/* SiKlarna */._lI, {
                                size: "2.2rem"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaIdeal */.M0e, {
                                size: "2.2rem"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(gr_index_esm/* GrAmex */.ZOg, {
                                size: "2.5rem"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiVisaLine */.yT$, {
                                size: "2.5rem"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var footer_nav = (FooterNav);

;// CONCATENATED MODULE: ./src/modules/layout/templates/footer/index.tsx


var Footer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "bg-darkTone text-neutral-50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_nav, {})
    });
};
/* harmony default export */ var footer = (Footer);

// EXTERNAL MODULE: ./src/modules/common/icons/arrow-right.tsx
var arrow_right = __webpack_require__(37233);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/lib/context/mobile-menu-context.tsx + 2 modules
var mobile_menu_context = __webpack_require__(53300);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/modules/common/components/modal/index.tsx
var modal = __webpack_require__(95847);
// EXTERNAL MODULE: ./node_modules/@vectopus/atlas-icons-react/index.js
var atlas_icons_react = __webpack_require__(94163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/modules/search/templates/desktop-search-modal/index.tsx






var DynamicInstantSearch = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5362), __webpack_require__.e(1248)]).then(__webpack_require__.bind(__webpack_require__, 41248));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41248)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading..."
        });
    }
});
var DesktopSearchModal = function() {
    var ref = (0,use_toggle_state/* default */.Z)(), state = ref.state, close = ref.close, open = ref.open;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "Zoeken",
                onClick: open,
                className: "flex items-center gap-x-3 h-full hover:text-brand",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atlas_icons_react/* OrganismMagnifyingGlass */.vv$, {
                        size: 25,
                        weight: "thin"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "hidden small:inline-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            defaultMessage: "Zoeken",
                            id: "Search"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                isOpen: state,
                close: close,
                size: "large",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-1 h-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default.Body */.Z.Body, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicInstantSearch, {})
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var desktop_search_modal = (DesktopSearchModal);

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var popover = __webpack_require__(86215);
// EXTERNAL MODULE: ./src/lib/context/cart-dropdown-context.tsx
var cart_dropdown_context = __webpack_require__(37052);
;// CONCATENATED MODULE: ./src/modules/layout/components/cart-dropdown/index.tsx









var DynamicCartDropdownContent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7115), __webpack_require__.e(6483), __webpack_require__.e(5646)]).then(__webpack_require__.bind(__webpack_require__, 15646));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15646)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Loading..."
        });
    }
});
var CartDropdown = function() {
    var ref = (0,medusa_react_esm/* useCart */.jD1)(), cart = ref.cart, totalItems = ref.totalItems;
    var ref1 = (0,cart_dropdown_context/* useCartDropdown */.qt)(), state = ref1.state, open = ref1.open, close = ref1.close;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full z-50",
        onMouseEnter: open,
        onMouseLeave: close,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J, {
            className: "relative h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/winkelwagen",
                    passHref: true,
                    prefetch: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                        "aria-label": "Winkelwagen",
                        className: "h-full text-small lg:text-base font-mono relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "cart-title",
                                    defaultMessage: "Winkelwagen"
                                })
                            }),
                            (totalItems !== null && totalItems !== void 0 ? totalItems : 0) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atlas_icons_react/* ShoppingCartHouse */.j$i, {
                                size: 25,
                                weight: "thin"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atlas_icons_react/* ShopCart */.KqZ, {
                                size: 25,
                                weight: "thin"
                            }),
                            totalItems > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-sans ml-1 text-xs rounded-full w-[18px] h-[18px] -right-[10px] -mt-[10px] absolute inline-block align-middle text-white bg-brand pt-[1px]",
                                children: totalItems
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    show: state,
                    as: react.Fragment,
                    enter: "transition ease-out duration-200",
                    enterFrom: "opacity-0 translate-y-1",
                    enterTo: "opacity-100 translate-y-0",
                    leave: "transition ease-in duration-150",
                    leaveFrom: "opacity-100 translate-y-0",
                    leaveTo: "opacity-0 translate-y-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                        static: true,
                        className: "hidden small:block absolute top-[calc(100%+1px)] right-0 bg-white border-x border-b border-gray-200 w-[382px] text-gray-900",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicCartDropdownContent, {
                            cart: cart
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var cart_dropdown = (CartDropdown);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/lib/util/get-precentage-diff.ts
var get_precentage_diff = __webpack_require__(72702);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
;// CONCATENATED MODULE: ./src/lib/hooks/use-layout-data.tsx







var fetchCollectionData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var collections, offset, count;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    collections = [];
                    offset = 0;
                    count = 1;
                    _state.label = 1;
                case 1:
                    return [
                        4,
                        config/* medusaClient.collections.list */.pZ.collections.list({
                            offset: offset
                        }).then(function(param) {
                            var newCollections = param.collections, newCount = param.count;
                            collections = (0,_to_consumable_array/* default */.Z)(collections).concat((0,_to_consumable_array/* default */.Z)(newCollections));
                            count = newCount;
                            offset = collections.length;
                        }).catch(function(_) {
                            count = 0;
                        })
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    if (collections.length < count) return [
                        3,
                        1
                    ];
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        collections.map(function(c) {
                            return {
                                id: c.id,
                                title: c.title,
                                handle: c.handle
                            };
                        })
                    ];
            }
        });
    });
    return function fetchCollectionData() {
        return _ref.apply(this, arguments);
    };
}();
var useNavigationCollections = function() {
    var queryResults = (0,es.useQuery)("navigation_collections", fetchCollectionData, {
        staleTime: Infinity,
        refetchOnWindowFocus: false
    });
    return queryResults;
};
var fetchFeaturedProducts = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(cartId, region) {
        var products;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        config/* medusaClient.products.list */.pZ.products.list({
                            is_giftcard: false,
                            limit: 4,
                            id: [
                                "prod_01GTAQXX384PRXBRZTPRFYQPQH",
                                "prod_01GTAQS350TNEK0WQBQXMDJDMD",
                                "prod_01GTAJG4SFKTM1K5RF4A1D6HNB",
                                "prod_01GR59Q17DM303PEQTF83MZ53R",
                                "prod_01GQDNN6S7Z9NRC85VBD82HHEX",
                                "prod_01GPYSYFNKYG4WA59S8H3RV3KG"
                            ],
                            cart_id: cartId
                        }).then(function(param) {
                            var products = param.products;
                            return products;
                        }).catch(function(_) {
                            return [];
                        })
                    ];
                case 1:
                    products = _state.sent();
                    return [
                        2,
                        products.filter(function(p) {
                            return !!p.variants;
                        }).map(function(p) {
                            var ref, ref1, ref2;
                            var variants = p.variants;
                            var cheapestVariant = variants.reduce(function(acc, curr) {
                                if (acc.calculated_price > curr.calculated_price) {
                                    return curr;
                                }
                                return acc;
                            }, variants[0]);
                            var calculatedPrice = (0,medusa_react_esm/* formatAmount */.dNj)({
                                amount: cheapestVariant.calculated_price,
                                region: region,
                                includeTaxes: false,
                                locale: "nl-NL"
                            });
                            var originalPrice = (0,medusa_react_esm/* formatAmount */.dNj)({
                                amount: cheapestVariant.original_price,
                                region: region,
                                includeTaxes: false,
                                locale: "nl-NL"
                            });
                            var ref3;
                            return {
                                id: p.id,
                                title: p.title,
                                handle: p.handle,
                                thumbnail: p.thumbnail,
                                secondThumbnail: (ref3 = (ref = p.images[1]) === null || ref === void 0 ? void 0 : ref.url) !== null && ref3 !== void 0 ? ref3 : null,
                                presale: !!((ref2 = p === null || p === void 0 ? void 0 : (ref1 = p.tags) === null || ref1 === void 0 ? void 0 : ref1.find(function(tag) {
                                    return (tag === null || tag === void 0 ? void 0 : tag.value) === "presale";
                                })) === null || ref2 === void 0 ? void 0 : ref2.id),
                                inStock: (p === null || p === void 0 ? void 0 : p.variants.length) > 1 && (p === null || p === void 0 ? void 0 : p.variants.reduce(function(acc, cur) {
                                    return (cur === null || cur === void 0 ? void 0 : cur.allow_backorder) ? 1 : Math.max(0, cur === null || cur === void 0 ? void 0 : cur.inventory_quantity);
                                }, 0)) > 0 || (p === null || p === void 0 ? void 0 : p.variants[0].inventory_quantity) > 0,
                                price: cheapestVariant ? {
                                    calculated_price: calculatedPrice.substring(calculatedPrice.length - 2) === "00" ? "".concat(calculatedPrice.substring(1, calculatedPrice.length - 2), "-") : calculatedPrice,
                                    original_price: originalPrice.substring(originalPrice.length - 2) === "00" ? "".concat(originalPrice.substring(1, originalPrice.length - 2), "-") : originalPrice,
                                    difference: (0,get_precentage_diff/* getPercentageDiff */.p)(cheapestVariant.original_price, cheapestVariant.calculated_price),
                                    price_type: cheapestVariant.calculated_price_type
                                } : {
                                    calculated_price: "N/A",
                                    original_price: "N/A",
                                    difference: "N/A",
                                    price_type: "default"
                                }
                            };
                        })
                    ];
            }
        });
    });
    return function fetchFeaturedProducts(cartId, region) {
        return _ref.apply(this, arguments);
    };
}();
var useFeaturedProductsQuery = function() {
    var cart = (0,medusa_react_esm/* useCart */.jD1)().cart;
    var queryResults = (0,es.useQuery)([
        "layout_featured_products",
        cart === null || cart === void 0 ? void 0 : cart.id,
        cart === null || cart === void 0 ? void 0 : cart.region
    ], function() {
        return fetchFeaturedProducts(cart === null || cart === void 0 ? void 0 : cart.id, cart === null || cart === void 0 ? void 0 : cart.region);
    }, {
        enabled: !!(cart === null || cart === void 0 ? void 0 : cart.id) && !!(cart === null || cart === void 0 ? void 0 : cart.region),
        staleTime: Infinity,
        refetchOnWindowFocus: false
    });
    return queryResults;
};

// EXTERNAL MODULE: ./src/lib/util/repeat.ts
var repeat = __webpack_require__(61692);
// EXTERNAL MODULE: ./src/modules/products/components/product-preview/index.tsx + 1 modules
var product_preview = __webpack_require__(84874);
// EXTERNAL MODULE: ./src/modules/skeletons/components/skeleton-product-preview/index.tsx
var skeleton_product_preview = __webpack_require__(15986);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/modules/layout/components/header-menu/index.tsx















var HeaderMenu = function() {
    var ref = (0,react.useState)(""), open = ref[0], setOpen = ref[1];
    var push = (0,router.useRouter)().push;
    var ref1 = useNavigationCollections(), collections = ref1.data, loadingCollections = ref1.isLoading;
    var ref2 = useFeaturedProductsQuery(), products = ref2.data, loadingProducts = ref2.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-end h-full items-center w-full md:w-auto justify-around md:justify-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
                className: "hidden md:flex text-xs md:text-lg",
                onMouseEnter: function() {
                    return setOpen("panelen");
                },
                onMouseLeave: function() {
                    return setOpen("");
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/akoestische-panelen",
                            passHref: true,
                            prefetch: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (0,clsx_m/* default */.Z)("relative flex px-2 transition-all ease-out duration-500 ", "hover:text-brand"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                    className: (0,clsx_m/* default */.Z)("relative py-2 md:py-4 flex items-center transition-all ease-out duration-500"),
                                    onClick: function() {
                                        return push("/akoestische-panelen");
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "main-menu-item",
                                        defaultMessage: "Shop Akupanelen"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                            show: open === "panelen",
                            as: react.Fragment,
                            enter: "transition transform origin-top ease-in-out duration-300",
                            enterFrom: "scale-y-0",
                            enterTo: "scale-y-100",
                            leave: "transition ease-in transform origin-top duration-200",
                            leaveFrom: "scale-y-100",
                            leaveTo: "scale-y-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                                static: true,
                                className: "absolute top-full inset-x-0 text-base text-gray-700 z-30 border-y border-gray-200A",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative bg-white py-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-start content-container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col flex-1 max-w-[30%]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/akoestische-panelen",
                                                        prefetch: false,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "text-lg font-bold text-gray-900 mb-4 cursor-pointer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                id: "collections-title",
                                                                defaultMessage: "Akoestische panelen"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex items-start text-lg",
                                                        children: [
                                                            collections && (0,lodash.chunk)(collections, 6).map(function(chunk, index) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                    className: "min-w-[152px] max-w-[200px] pr-4",
                                                                    children: chunk.map(function(collection) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "pb-3",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/akoestische-panelen/".concat(collection.handle),
                                                                                prefetch: false,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    onClick: function() {
                                                                                        return setOpen("");
                                                                                    },
                                                                                    children: collection.title
                                                                                })
                                                                            })
                                                                        }, collection.id);
                                                                    })
                                                                }, index);
                                                            }),
                                                            loadingCollections && (0,repeat/* default */.Z)(6).map(function(index) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "w-12 h-4 bg-gray-100 animate-pulse"
                                                                }, index);
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "grid grid-cols-3 gap-4",
                                                    children: [
                                                        products === null || products === void 0 ? void 0 : products.slice(0, 3).map(function(product) {
                                                            return /*#__PURE__*/ (0,react.createElement)(product_preview/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                                key: product.id
                                                            }));
                                                        }),
                                                        loadingProducts && (0,repeat/* default */.Z)(3).map(function(index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_product_preview/* default */.Z, {}, index);
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            }, "menu-panelen"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/akoestische-panelen",
                passHref: true,
                prefetch: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (0,clsx_m/* default */.Z)("relative flex px-2 transition-all ease-out duration-500 ", "hover:text-brand relative py-2 md:py-4 items-center text-xs md:text-lg flex md:hidden"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "main-menu-akoestische-panelen",
                        defaultMessage: "Shop Akupanelen"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/akoestische-panelen/samples",
                passHref: true,
                prefetch: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (0,clsx_m/* default */.Z)("relative flex px-2 transition-all ease-out duration-500 ", "hover:text-brand relative py-2 md:py-4 flex items-center text-xs md:text-lg"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "main-menu-samples",
                        defaultMessage: "Samples"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/zakelijk",
                passHref: true,
                prefetch: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (0,clsx_m/* default */.Z)("relative flex px-2 transition-all ease-out duration-500 ", "hover:text-brand relative py-2 md:py-4 flex items-center text-xs md:text-lg"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "main-menu-zakelijk",
                        defaultMessage: "Zakelijk bestellen"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var header_menu = (HeaderMenu);

// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/react-tooltip.esm.min.js
var react_tooltip_esm_min = __webpack_require__(39145);
;// CONCATENATED MODULE: ./src/modules/common/components/hamburger/index.tsx



var Hamburger = function(param) {
    var setOpen = param.setOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: "w-10 h-10 relative focus:outline-none",
        onClick: setOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: "Open main menu"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "block w-5 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        "aria-hidden": "true",
                        className: (0,clsx_m/* default */.Z)("block absolute h-0.5 w-5 rounded-sm bg-current -translate-y-1.5 ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        "aria-hidden": "true",
                        className: (0,clsx_m/* default */.Z)("block absolute  h-0.5 w-5 bg-current rounded-sm transform")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        "aria-hidden": "true",
                        className: (0,clsx_m/* default */.Z)("block absolute  h-0.5 w-5 bg-current rounded-sm translate-y-1.5")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var hamburger = (Hamburger);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 7 modules
var dialog = __webpack_require__(98831);
;// CONCATENATED MODULE: ./src/modules/mobile-menu/components/container/index.tsx




var Container = function(param) {
    var children = param.children;
    var ref = (0,mobile_menu_context/* useMobileMenu */.Sn)(), state = ref.state, close = ref.close;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: state,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
            as: "div",
            className: "fixed inset-0 flex z-50",
            onClose: close,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    as: react.Fragment,
                    enter: "ease-in-out duration-500",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in-out duration-500",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Overlay */.V.Overlay, {
                        className: "absolute inset-0 bg-gray-700 bg-opacity-75 transition-opacity backdrop-blur-sm"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    as: react.Fragment,
                    enter: "transition ease-in-out duration-500 transform",
                    enterFrom: "-translate-x-full",
                    enterTo: "translate-x-0",
                    leave: "transition ease-in-out duration-500 transform",
                    leaveFrom: "translate-x-0",
                    leaveTo: "-translate-x-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 overflow-hidden trans",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pointer-events-none fixed inset-y-0 right-left flex max-w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative w-screen pointer-events-auto bg-white text-gray-900 flex flex-col overflow-y-auto",
                                children: children
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var container = (Container);

;// CONCATENATED MODULE: ./src/modules/mobile-menu/templates/index.tsx





var DynamicCountryMenu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4856).then(__webpack_require__.bind(__webpack_require__, 64856));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64856)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading..."
        });
    }
});
var DynamicSearchMenu = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5362), __webpack_require__.e(5430)]).then(__webpack_require__.bind(__webpack_require__, 45430));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45430)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading..."
        });
    }
});
var DynamicMainMenu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 642).then(__webpack_require__.bind(__webpack_require__, 50642));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50642)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading..."
        });
    }
});
var MobileMenu = function() {
    var ref = (0,mobile_menu_context/* useMobileMenu */.Sn)(), _screen = (0,_sliced_to_array/* default */.Z)(ref.screen, 1), currentScreen = _screen[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col flex-1",
            children: function() {
                switch(currentScreen){
                    case "country":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicCountryMenu, {});
                    case "search":
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicSearchMenu, {});
                    default:
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicMainMenu, {});
                }
            }()
        })
    });
};
/* harmony default export */ var templates = (MobileMenu);

;// CONCATENATED MODULE: ./src/modules/layout/templates/header2/logo.tsx


var Logo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        version: "1.1",
        id: "akupanel_logo",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 492.31 65.79",
        className: (0,clsx_m/* default */.Z)("transition-all w-200 md:w-330 h-[24px] md:h-[46px] for-white-bg"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "st0",
                        d: "M29.5,57.8c-13,0-23.8-10-25-22.7h21.7v14v1.5v3c1.1,0.2,2.1,0.3,3.2,0.3c0.5,0,1,0,1.5-0.1v-3.2v-1.3V7.7V6.3 V3.3c-0.5,0-1,0-1.5,0c-13.8,0-25.4,9.5-28.6,22.4h4.6C8.3,16.2,16.4,9.2,26.3,7.9v22.4H4.6H0.8H0.1C0,31.1,0,31.9,0,32.7 C0,49,13.2,62.2,29.5,62.2c13.9,0,25.5-9.6,28.6-22.4h-4.6C50.5,50.2,40.9,57.8,29.5,57.8z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        className: "st1",
                        d: "M35.8,3.9v2.4v2.1v39.7v2.2v2.6c1.7-0.5,3.3-1.3,4.7-2.2v-0.4v-5.1V10.2c7.6,3.7,13.1,11.3,13.9,20.1h-8.5 c0.1,0.8,0.2,1.6,0.2,2.4c0,0.8-0.1,1.6-0.2,2.3h8.5h2.1h2.3c0.1-0.8,0.1-1.5,0.1-2.3C59,18.6,49,6.8,35.8,3.9z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M76.3,54.6c-0.3,0-0.7-0.1-1-0.2c-0.4-0.1-0.7-0.3-0.9-0.6C74.1,53.6,74,53.3,74,53c0-0.2,0-0.3,0.1-0.4l12.5-40.5 c0.2-0.5,0.5-0.9,0.9-1.1c0.4-0.2,0.9-0.3,1.4-0.3c0.6,0,1.1,0.1,1.5,0.4c0.5,0.2,0.7,0.6,0.9,1.1l12.4,40.5c0,0.1,0.1,0.2,0.1,0.4 c0,0.3-0.1,0.6-0.4,0.9c-0.2,0.3-0.5,0.5-0.9,0.6c-0.4,0.2-0.7,0.2-1.1,0.2c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.2-0.5-0.4-0.6-0.8 l-2.7-9.2H80.6l-2.7,9.2c-0.1,0.4-0.3,0.6-0.6,0.8C77,54.6,76.7,54.6,76.3,54.6z M81.6,41h14.5l-7.2-24L81.6,41z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M111.4,54.6c-0.5,0-1-0.1-1.4-0.4c-0.4-0.3-0.6-0.6-0.6-1.2V12.5c0-0.5,0.2-0.9,0.6-1.1c0.4-0.2,0.9-0.4,1.4-0.4 c0.5,0,0.9,0.1,1.3,0.4c0.4,0.2,0.6,0.6,0.6,1.1v21.1l17.2-22c0.3-0.4,0.7-0.6,1.2-0.6c0.4,0,0.7,0.1,1,0.3 c0.3,0.2,0.6,0.5,0.8,0.8c0.2,0.3,0.3,0.6,0.3,1c0,0.1,0,0.3-0.1,0.4c0,0.2-0.1,0.3-0.2,0.4l-12.8,15.9L135.6,52 c0.2,0.2,0.2,0.5,0.2,0.8c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.5-0.8,0.7c-0.3,0.2-0.7,0.3-1.1,0.3c-0.3,0-0.5-0.1-0.8-0.2 c-0.3-0.2-0.5-0.4-0.7-0.7l-13.8-20.6l-4.9,6.1v13.7c0,0.5-0.2,0.9-0.6,1.2C112.4,54.5,111.9,54.6,111.4,54.6z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M152.9,55c-2.3,0-4.5-0.4-6.3-1.3c-1.9-0.8-3.4-2.2-4.5-4.1c-1.1-1.9-1.7-4.4-1.7-7.5V12.5c0-0.5,0.2-0.9,0.6-1.1 c0.4-0.2,0.9-0.4,1.4-0.4c0.5,0,1,0.1,1.4,0.4c0.4,0.2,0.6,0.6,0.6,1.1v29.7c0,3.1,0.8,5.4,2.3,6.9c1.5,1.5,3.6,2.2,6.3,2.2 c2.7,0,4.8-0.7,6.3-2.2c1.5-1.5,2.3-3.8,2.3-6.9V12.5c0-0.5,0.2-0.9,0.6-1.1c0.4-0.2,0.9-0.4,1.4-0.4c0.5,0,1,0.1,1.4,0.4 c0.4,0.2,0.6,0.6,0.6,1.1v29.7c0,3.1-0.5,5.6-1.6,7.5c-1.1,1.9-2.6,3.2-4.5,4.1C157.4,54.6,155.2,55,152.9,55z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M176.2,54.6c-0.5,0-1-0.1-1.4-0.4c-0.4-0.3-0.6-0.6-0.6-1.2V12.5c0-0.4,0.1-0.7,0.4-1s0.7-0.4,1.2-0.5h11 c2.3,0,4.4,0.4,6.3,1.3c1.9,0.8,3.3,2.2,4.4,4c1.1,1.8,1.6,4.3,1.6,7.4v0.6c0,3.1-0.5,5.6-1.6,7.5c-1.1,1.9-2.6,3.2-4.5,4.1 c-1.9,0.8-4,1.3-6.3,1.3h-8.6v16.1c0,0.5-0.2,0.9-0.6,1.2C177.2,54.5,176.7,54.6,176.2,54.6z M178.2,33.6h8.6 c2.7,0,4.7-0.7,6.2-2.2c1.5-1.5,2.2-3.8,2.2-6.9v-0.7c0-3.1-0.7-5.4-2.2-6.9c-1.5-1.5-3.6-2.2-6.2-2.2h-8.6V33.6z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M202.2,54.6c-0.3,0-0.7-0.1-1-0.2c-0.4-0.1-0.7-0.3-0.9-0.6c-0.2-0.3-0.4-0.5-0.4-0.9c0-0.2,0-0.3,0.1-0.4l12.5-40.5 c0.2-0.5,0.5-0.9,0.9-1.1c0.4-0.2,0.9-0.3,1.4-0.3c0.6,0,1.1,0.1,1.5,0.4c0.5,0.2,0.7,0.6,0.9,1.1l12.4,40.5c0,0.1,0.1,0.2,0.1,0.4 c0,0.3-0.1,0.6-0.4,0.9c-0.2,0.3-0.5,0.5-0.9,0.6c-0.4,0.2-0.7,0.2-1.1,0.2c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.2-0.5-0.4-0.6-0.8 l-2.7-9.2h-16.5l-2.7,9.2c-0.1,0.4-0.3,0.6-0.6,0.8C202.9,54.6,202.6,54.6,202.2,54.6z M207.5,41H222l-7.2-24L207.5,41z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M237.3,54.6c-0.5,0-1-0.1-1.4-0.4c-0.4-0.3-0.6-0.6-0.6-1.2V12.5c0-0.6,0.2-0.9,0.6-1.2c0.4-0.2,0.9-0.3,1.4-0.3 c0.5,0,0.9,0.1,1.3,0.4c0.4,0.3,0.7,0.6,1,1c0.3,0.4,0.6,0.9,0.8,1.4l16.1,31.7v-33c0-0.5,0.2-0.9,0.6-1.1c0.4-0.2,0.9-0.4,1.4-0.4 c0.5,0,0.9,0.1,1.3,0.4c0.4,0.2,0.6,0.6,0.6,1.1v40.6c0,0.5-0.2,0.9-0.6,1.2s-0.9,0.4-1.3,0.4c-0.6,0-1.1-0.2-1.5-0.7 c-0.5-0.5-0.8-1-1.1-1.6l-16.6-32.3v33c0,0.5-0.2,0.9-0.6,1.2C238.3,54.5,237.8,54.6,237.3,54.6z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M271.4,54.6c-0.4,0-0.8-0.1-1.2-0.4c-0.4-0.3-0.6-0.6-0.6-1.2V12.6c0-0.5,0.2-0.9,0.6-1.2c0.4-0.3,0.8-0.4,1.2-0.4h21.2 c0.5,0,0.9,0.2,1.1,0.6c0.2,0.4,0.4,0.8,0.4,1.2c0,0.5-0.1,0.9-0.4,1.3c-0.3,0.4-0.6,0.6-1.1,0.6h-19.1v16.4h9.4 c0.5,0,0.8,0.2,1.1,0.5c0.3,0.4,0.4,0.8,0.4,1.3c0,0.4-0.1,0.8-0.4,1.1s-0.6,0.5-1.1,0.5h-9.4V51h19.1c0.5,0,0.8,0.2,1.1,0.5 c0.3,0.4,0.4,0.8,0.4,1.3c0,0.4-0.1,0.8-0.4,1.2s-0.6,0.6-1.1,0.6H271.4z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M301.7,54.6c-0.4,0-0.8-0.1-1.2-0.4c-0.4-0.3-0.6-0.6-0.6-1.2V12.5c0-0.5,0.2-0.9,0.6-1.1c0.4-0.2,0.9-0.4,1.4-0.4 c0.5,0,0.9,0.1,1.3,0.4c0.4,0.2,0.6,0.6,0.6,1.1V51h17c0.5,0,0.8,0.2,1,0.6c0.2,0.4,0.3,0.8,0.3,1.2c0,0.5-0.1,0.9-0.3,1.3 s-0.5,0.6-1,0.6H301.7z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M349.8,55.1c-2.6,0-4.9-0.4-6.9-1.1c-2-0.8-3.5-1.7-4.7-2.8s-1.7-2.1-1.7-3.1c0-0.5,0.1-1,0.4-1.5c0.3-0.5,0.6-1,1-1.3 c0.4-0.4,0.9-0.6,1.3-0.6c0.6,0,1.1,0.2,1.6,0.7c0.5,0.5,1.1,1,1.8,1.6c0.7,0.6,1.6,1.2,2.7,1.7c1.1,0.5,2.4,0.7,4.1,0.7 c1.4,0,2.7-0.2,3.8-0.7c1.1-0.5,2-1.2,2.7-2.1s1-2.1,1-3.6c0-1.5-0.3-2.8-1-3.8c-0.7-1-1.6-1.8-2.8-2.5c-1.2-0.7-2.4-1.3-3.8-1.8 c-1.4-0.6-2.7-1.2-4.1-1.8s-2.7-1.4-3.8-2.3c-1.2-0.9-2.1-2-2.8-3.4c-0.7-1.4-1-3.1-1-5.2c0-2.2,0.4-4,1.2-5.5 c0.8-1.5,1.9-2.6,3.3-3.5c1.4-0.9,2.8-1.5,4.5-1.9c1.6-0.4,3.2-0.6,4.8-0.6c1,0,2.1,0.1,3.3,0.2c1.2,0.1,2.4,0.4,3.6,0.7 c1.2,0.3,2.1,0.8,2.9,1.3c0.8,0.6,1.1,1.2,1.1,2c0,0.4-0.1,0.9-0.3,1.4s-0.5,1-0.9,1.4c-0.4,0.4-0.9,0.6-1.5,0.6 c-0.5,0-1.1-0.2-1.7-0.6s-1.5-0.8-2.5-1.1c-1-0.4-2.4-0.6-4-0.6c-1.4,0-2.7,0.2-3.8,0.6c-1.1,0.4-2,1-2.7,1.8c-0.6,0.8-1,1.8-1,3.1 s0.3,2.3,1,3.1c0.7,0.8,1.6,1.5,2.8,2.1c1.2,0.6,2.4,1.1,3.8,1.6c1.4,0.5,2.7,1.1,4.1,1.8c1.4,0.7,2.6,1.5,3.8,2.5 c1.2,1,2.1,2.3,2.8,3.8c0.7,1.5,1,3.4,1,5.7c0,2.9-0.6,5.2-1.8,7.1s-2.8,3.3-4.8,4.2C354.7,54.7,352.4,55.1,349.8,55.1z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M380.3,54.6c-0.8,0-1.5-0.2-2.2-0.5s-1-0.9-1-1.6V16.8h-9.2c-0.6,0-1.1-0.3-1.5-0.9c-0.4-0.6-0.5-1.3-0.5-2 c0-0.7,0.2-1.4,0.5-2c0.3-0.6,0.8-0.9,1.6-0.9h24.8c0.8,0,1.3,0.3,1.6,0.9s0.5,1.2,0.5,1.9c0,0.8-0.2,1.5-0.5,2.1 c-0.3,0.6-0.9,0.9-1.6,0.9h-9.2v35.7c0,0.7-0.3,1.2-1,1.6S381,54.6,380.3,54.6z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M411.2,55c-2.5,0-4.8-0.4-6.8-1.3c-2-0.9-3.6-2.3-4.8-4.2c-1.2-1.9-1.8-4.5-1.8-7.8V24.3c0-3.2,0.6-5.8,1.8-7.8 c1.2-1.9,2.8-3.4,4.8-4.2c2-0.9,4.3-1.3,6.8-1.3c2.5,0,4.8,0.4,6.8,1.3c2,0.9,3.6,2.3,4.8,4.2s1.8,4.5,1.8,7.8v17.4 c0,3.2-0.6,5.8-1.8,7.8c-1.2,1.9-2.8,3.4-4.8,4.2C416.1,54.6,413.8,55,411.2,55z M411.2,49.4c2.2,0,4-0.6,5.3-1.9s1.9-3.2,1.9-5.8 V24.3c0-2.6-0.6-4.6-1.9-5.8c-1.3-1.3-3-1.9-5.2-1.9c-2.2,0-4,0.6-5.2,1.9c-1.3,1.3-1.9,3.2-1.9,5.8v17.4c0,2.6,0.6,4.6,1.8,5.8 S409,49.4,411.2,49.4z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M455.6,54.8c-0.5,0-1-0.2-1.4-0.5c-0.4-0.4-0.8-0.8-1-1.3l-8.8-17.1h-6v16.6c0,0.7-0.3,1.2-1,1.6s-1.4,0.5-2.2,0.5 c-0.8,0-1.5-0.2-2.2-0.5s-1-0.9-1-1.6V13.1c0-0.6,0.2-1,0.6-1.4c0.4-0.4,0.9-0.6,1.6-0.6h11.3c2.5,0,4.8,0.4,6.9,1.1 c2.1,0.7,3.7,2,5,3.8c1.2,1.8,1.8,4.2,1.8,7.3c0,2.4-0.4,4.4-1.1,6c-0.7,1.6-1.7,2.9-3,3.8s-2.7,1.6-4.3,2.1l8.4,15.7 c0.1,0.1,0.1,0.3,0.2,0.4c0,0.2,0.1,0.3,0.1,0.4c0,0.5-0.2,1-0.6,1.5c-0.4,0.5-0.9,0.9-1.5,1.2C456.9,54.7,456.3,54.8,455.6,54.8z M438.4,30.8h7.2c2.2,0,4-0.5,5.3-1.6c1.3-1.1,2-2.9,2-5.5c0-2.6-0.7-4.4-2-5.5c-1.3-1.1-3.1-1.6-5.3-1.6h-7.2V30.8z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M467.9,54.6c-0.7,0-1.3-0.2-1.9-0.5c-0.6-0.4-0.9-0.9-0.9-1.6V13.1c0-0.7,0.3-1.2,0.9-1.6c0.6-0.4,1.2-0.5,1.9-0.5h21.2 c0.8,0,1.3,0.3,1.6,0.9s0.5,1.2,0.5,1.8c0,0.8-0.2,1.4-0.5,2c-0.4,0.6-0.9,0.9-1.6,0.9h-17.7v13.7h9.2c0.7,0,1.2,0.3,1.6,0.8 c0.4,0.5,0.5,1.1,0.5,1.8c0,0.6-0.2,1.1-0.5,1.6s-0.9,0.8-1.6,0.8h-9.2V49h17.7c0.7,0,1.2,0.3,1.6,0.8c0.4,0.6,0.5,1.2,0.5,2 c0,0.6-0.2,1.3-0.5,1.8s-0.9,0.9-1.6,0.9H467.9z"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var logo = (Logo);

// EXTERNAL MODULE: ./src/lib/hooks/use-previews.tsx + 1 modules
var use_previews = __webpack_require__(42984);
// EXTERNAL MODULE: ./src/lib/data/index.ts
var data = __webpack_require__(39594);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./src/lib/data/posts.ts
var posts = __webpack_require__(46475);
;// CONCATENATED MODULE: ./src/modules/layout/templates/header2/index.tsx




























var CartPopupContent = function() {
    var cart = (0,medusa_react_esm/* useCart */.jD1)().cart;
    var ref = (0,cart_dropdown_context/* useCartDropdown */.qt)(), productId = ref.productId, closeCartPopup = ref.closeCartPopup;
    var push = (0,router.useRouter)().push;
    var queryParams = (0,react.useMemo)(function() {
        var params = {};
        params.collection_id = [
            "pcol_01GQDXMSSVNZHN0FQ41MC4RCCZ"
        ];
        return params;
    }, [
        cart === null || cart === void 0 ? void 0 : cart.id
    ]);
    var ref1 = (0,es.useInfiniteQuery)([
        "accessories",
        queryParams,
        cart === null || cart === void 0 ? void 0 : cart.id
    ], function(param) {
        var pageParam = param.pageParam;
        return (0,data/* fetchProductsList */._q)({
            pageParam: pageParam,
            queryParams: queryParams
        });
    }, {
        getNextPageParam: function(lastPage) {
            return lastPage.nextPage;
        }
    }), infiniteData = ref1.data, hasNextPage = ref1.hasNextPage, fetchNextPage = ref1.fetchNextPage, isLoadingProducts = ref1.isLoading, isFetchingNextPage = ref1.isFetchingNextPage;
    var tagMap = {
        prod_01GTAQXX384PRXBRZTPRFYQPQH: "ptag_01GTAQK42B0MR0ZCYP1YGWX63Z",
        prod_01GTAQS350TNEK0WQBQXMDJDMD: "ptag_01GTAQKNE9PB4R9A9ZKS9WQT5G",
        prod_01GTAJG4SFKTM1K5RF4A1D6HNB: "ptag_01GTAQK42B0MR0ZCYP1YGWX63Z",
        prod_01GR59Q17DM303PEQTF83MZ53R: "ptag_01GTAQKXCA7SRREPA7DNAXJPMX",
        prod_01GQDNN6S7Z9NRC85VBD82HHEX: "ptag_01GTAQK42B0MR0ZCYP1YGWX63Z",
        prod_01GPYSYFNKYG4WA59S8H3RV3KG: "ptag_01GTAQNZPEVK8EHR93E2D6R02P"
    };
    var previews = (0,use_previews/* default */.Z)({
        pages: infiniteData === null || infiniteData === void 0 ? void 0 : infiniteData.pages,
        region: cart === null || cart === void 0 ? void 0 : cart.region
    }).filter(function(p) {
        var ref;
        return p.title.toLowerCase().includes("high tack") || p.title.toLowerCase().includes("montage schroeven") || ((ref = p.tags) === null || ref === void 0 ? void 0 : ref.some(function(t) {
            return [
                tagMap[productId || ""]
            ].includes(t);
        }));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-3xl font-semibold flex items-center gap-x-4 pr-8 pb-6 pt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "Vaak samen gekocht"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-6 gap-6 mb-4",
                children: [
                    previews.sort(function(a, b) {
                        if (a.title.toLowerCase().includes("high tack") || a.title.toLowerCase().includes("montage schroeven")) return 1;
                        else if (b.title.toLowerCase().includes("high tack") || b.title.toLowerCase().includes("montage schroeven")) return -1;
                        else return 0;
                    }).map(function(p, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("bg-white p-2 md:p-6 gap-y-2 md:gap-y-6 border border-neutral-200", {
                                "hidden md:flex": i > 1
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_preview/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                                doubleColl: false,
                                newStyle: true
                            }))
                        }, p.id);
                    }),
                    isLoadingProducts && !previews.length && (0,repeat/* default */.Z)(8).map(function(index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_product_preview/* default */.Z, {})
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "border-t border-t-gray-600 mt-8 pt-4 gap-x-1 md:gap-x-8 flex flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_button/* default */.Z, {
                        onClick: function(e) {
                            closeCartPopup();
                        },
                        className: "w-auto !text-white !text-xs  md:!text-base !min-h-[20px] !px-3 !py-2 md:!min-h-[50px] md:!px-5 md:!py-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineLeft */.CF5, {
                                size: 28,
                                className: "mr-3"
                            }),
                            " Verder Winkelen"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_button/* default */.Z, {
                        onClick: function(e) {
                            closeCartPopup();
                            push("/winkelwagen");
                        },
                        className: "!bg-blue-700 !border-blue-700 hover:!bg-blue-800 !text-white w-auto mr-auto  !text-xs md:!text-base !min-h-[20px] !px-3 !py-2 md:!min-h-[50px] md:!px-5 md:!py-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineRight */.Td4, {
                                size: 28,
                                className: "mr-3"
                            }),
                            " Verder naar bestellen"
                        ]
                    })
                ]
            })
        ]
    });
};
var Header = function() {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), mounted = ref3[0], setMounted = ref3[1];
    var ref4 = (0,cart_dropdown_context/* useCartDropdown */.qt)(), cartPopupState = ref4.cartPopupState, closeCartPopup = ref4.closeCartPopup, openCartPopup = ref4.openCartPopup, product = ref4.product;
    var ref5 = (0,es.useQuery)([
        "get_usps"
    ], function() {
        return (0,posts/* getWebsiteItems */.VR)();
    }), data = ref5.data, isError = ref5.isError, isSuccess = ref5.isSuccess, isLoading = ref5.isLoading;
    (0,react.useEffect)(function() {
        setMounted(true);
    }, []);
    var toggle = (0,mobile_menu_context/* useMobileMenu */.Sn)().toggle;
    var push = (0,router.useRouter)().push;
    var ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("special-usp-bar md:bg-darkTone text-white flex flex-row flex-wrap md:flex-nowrap justify-center lg:justify-end", "items-right w-full px-0 pt-1 md:pt-2 md:pb-1 text-xs md:text-sm", {
                    "bg-[#e6258b]": !isSuccess
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mr-0 md:mr-auto flex flex-col md:flex-row w-full md:w-auto md:h-auto text-lg leading-6 mb-1 md:mb-0 gap-x-2 md:gap-x-4 items-center px-0 md:px-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                                className: "w-full text-center flex align-items flex-wrap justify-evenly md:hidden text-xs gap-x-1",
                                children: isSuccess ? data === null || data === void 0 ? void 0 : (ref = data.items) === null || ref === void 0 ? void 0 : ref.map(function(usp) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            "✓ ",
                                            usp === null || usp === void 0 ? void 0 : usp.content
                                        ]
                                    });
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "✓ Laagste prijsgarantie"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "✓ Laagste verzendkosten"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "✓ Gratis verzending van akupanelen"
                                        })
                                    ]
                                })
                            }),
                            isSuccess ? (ref2 = data === null || data === void 0 ? void 0 : (ref1 = data.desktopitems) === null || ref1 === void 0 ? void 0 : ref1.sort(function(a, b) {
                                return a.Order - b.Order;
                            })) === null || ref2 === void 0 ? void 0 : ref2.map(function(usp) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("p", {
                                    className: "w-full md:w-auto text-center md:text-left hidden md:inline",
                                    children: usp === null || usp === void 0 ? void 0 : usp.content
                                });
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "w-full md:w-auto text-center md:text-left hidden md:inline",
                                        children: "Laagste prijsgarantie"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "w-full md:w-auto text-center md:text-left hidden md:inline",
                                        children: "Laagste verzendkosten"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "w-full md:w-auto text-center md:text-left hidden md:inline",
                                        children: "Beste kwaliteit"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "w-full md:w-auto text-center md:text-left hidden md:inline",
                                        children: "Snelle levering"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-darkTone md:bg-[transparent] px-2 py-1 md:pt-2 md:pb-1 md:px-8 flex justify-center w-full md:w-auto gap-x-2 md:gap-x-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/over-ons",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "Over Akupanel Store"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/reviews",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "Reviews"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/montage",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "Montage"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/verzend-retourbeleid",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "Verzending"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/inspiratie",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "Inspiratie"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/contact",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: "Contact"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("top-0 inset-x-0 z-50 group sticky"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                        className: (0,clsx_m/* default */.Z)("flex flex-row justify-center content-center relative px-4 md:px-8 mx-auto transition border-b duration-500 border-transparent", "bg-white border-gray-200 w-full py-2 md:py-0"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-1 flex flex-col justify-center items-center text-base font-normal tracking-wide",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        "aria-label": "Akupanel Store Logo",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("order-2 flex flex-row small:pt-3 gap-x-3 align-bottom transition duration-500 mx-auto"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block small:hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hamburger, {
                                            setOpen: toggle
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden small:flex h-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)("order-3 small:pt-3 flex flex-row content-center items-center gap-x-3 small:gap-x-6 transition duration-500"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_search_modal, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/account",
                                        passHref: true,
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            id: "account-icon",
                                            "aria-label": "Mijn Account",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atlas_icons_react/* Account */.mRj, {
                                                    size: 25,
                                                    weight: "thin"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_dropdown, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(templates, {}),
                            mounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_tooltip_esm_min/* Tooltip */.u, {
                                anchorId: "account-icon",
                                content: "Mijn account",
                                place: "bottom"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "flex small:hidden flex-row justify-center content-center relative px-4 md:px-8 mx-auto transition bg-white border-gray-200 w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: isSuccess ? ".special-usp-bar { background-color: ".concat((ref6 = data === null || data === void 0 ? void 0 : data.uspbannerdesktop) !== null && ref6 !== void 0 ? ref6 : "#262221", " !important;} @media (max-width:768px){ .special-usp-bar { background-color: ").concat((ref7 = data === null || data === void 0 ? void 0 : data.uspbanner) !== null && ref7 !== void 0 ? ref7 : "#E6258B", " !important;} }") : ""
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                className: "!max-w-[100%] md:!max-w-[80%] !p-4 md:!p-10",
                size: "large",
                isOpen: cartPopupState,
                close: closeCartPopup,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* default.Body */.Z.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col md:flex-row gap-x-4 bg-green-400 diagonal-background2 p-2 md:p-4 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-y-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-center md:text-left text-lg md:text-2xl font-bold text-white text-shadow",
                                            children: "Het artikel is toegevoegd aan je winkelwagen"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-center md:text-left font-semibold text-white text-shadow",
                                            children: product
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-y-1 ml-0 md:ml-auto mt-3 md:mt-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                            onClick: function(e) {
                                                closeCartPopup();
                                                push("/winkelwagen");
                                            },
                                            className: "ml-0 md:ml-auto !bg-blue-700 !border-blue-700 hover:!bg-blue-800 !text-white text-base",
                                            children: "Verder naar bestellen"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-center md:text-left font-semibold text-base !text-white text-shadow",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "cursor-pointer",
                                                onClick: function() {
                                                    closeCartPopup();
                                                },
                                                children: "Of verder winkelen"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPopupContent, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var header2 = (Header);

;// CONCATENATED MODULE: ./src/modules/layout/templates/index.tsx







var Layout = function(param) {
    var children = param.children;
    var ref = (0,router.useRouter)(), pathname = ref.pathname, asPath = ref.asPath;
    var ref1 = (0,react.useState)(true), showSampleAanvraag = ref1[0], setShowSampleAanvraag = ref1[1];
    (0,react.useEffect)(function() {
        if (pathname.includes("producten/[handle]") || pathname.includes("akoestische-panelen") || asPath.includes("producten/[handle]") || asPath.includes("akoestische-panelen")) setShowSampleAanvraag(false);
        return function() {
            return setShowSampleAanvraag(true);
        };
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header2, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "relative",
                children: children
            }),
            showSampleAanvraag && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/akoestische-panelen/samples",
                prefetch: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "fixed bottom-5 left-5 bg-brand text-white drop-shadow px-3 py-2 flex flex-row uppercase transition-all duration-300 group hover:pl-5 hover:pr-1 items-center gap-x-4 z-50",
                    children: [
                        "Samples aanvragen",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {
                            size: 18,
                            className: "transition-all group-hover:ml-2 duration-300"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {})
        ]
    });
};
/* harmony default export */ var layout_templates = (Layout);


/***/ }),

/***/ 84874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_preview; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/modules/products/components/thumbnail/index.tsx + 1 modules
var components_thumbnail = __webpack_require__(63628);
// EXTERNAL MODULE: ./src/lib/context/store-context.tsx + 1 modules
var store_context = __webpack_require__(40909);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var hi_index_esm = __webpack_require__(53854);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./src/lib/config.ts
var config = __webpack_require__(17590);
;// CONCATENATED MODULE: ./src/lib/util/fetchReviews.ts



var fetchReviews = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                fetch("".concat(config/* MEDUSA_BACKEND_URL */.n1, "store/products/").concat(id, "/reviews")).then(function(res) {
                    return res.json();
                })
            ];
        });
    });
    return function fetchReviews(id) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var util_fetchReviews = (fetchReviews);

// EXTERNAL MODULE: ./src/lib/context/cart-dropdown-context.tsx
var cart_dropdown_context = __webpack_require__(37052);
;// CONCATENATED MODULE: ./src/modules/products/components/product-preview/index.tsx












var Stars = function(param) {
    var loading = param.loading, data = param.data;
    var reviewRate = data.reduce(function(a, b) {
        return a + b.rating;
    }, 0) / data.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row items-center justify-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-4 h-4 bg-gray-200 rounded-full animate-pulse mr-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-4 h-4 bg-gray-200 rounded-full animate-pulse mr-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-4 h-4 bg-gray-200 rounded-full animate-pulse mr-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-4 h-4 bg-gray-200 rounded-full animate-pulse mr-2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-4 h-4 bg-gray-200 rounded-full animate-pulse mr-2"
                })
            ]
        }) : reviewRate > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row items-center justify-start",
            children: [
                (0,_to_consumable_array/* default */.Z)(Array(Math.ceil(reviewRate))).map(function(_, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        "aria-hidden": "true",
                        className: "w-5 h-5 text-yellow-400",
                        fill: "currentColor",
                        viewBox: "0 0 20 20",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: "Review star"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                            })
                        ]
                    });
                }),
                (0,_to_consumable_array/* default */.Z)(Array(5 - Math.ceil(reviewRate))).map(function(_, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        "aria-hidden": "true",
                        className: "w-5 h-5 text-gray-200",
                        fill: "currentColor",
                        viewBox: "0 0 20 20",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: "Review star"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                            })
                        ]
                    });
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "ml-1 text-xs",
                    children: [
                        "( ",
                        reviewRate,
                        " )"
                    ]
                })
            ]
        })
    });
};
var ProductPreview = function(param) {
    var id = param.id, title = param.title, handle = param.handle, thumbnail = param.thumbnail, secondThumbnail = param.secondThumbnail, deliveryDate = param.deliveryDate, presale = param.presale, inStock = param.inStock, price = param.price, variant = param.variant, _doubleColl = param.doubleColl, doubleColl = _doubleColl === void 0 ? false : _doubleColl, _newStyle = param.newStyle, newStyle = _newStyle === void 0 ? false : _newStyle;
    var ref;
    var ref1 = (0,cart_dropdown_context/* useCartDropdown */.qt)(), setProduct = ref1.setProduct, setProductId = ref1.setProductId;
    var addItem = (0,store_context/* useStore */.o)().addItem;
    var addToCart = function() {
        if (typeof variant !== "undefined") {
            setProduct(title);
            setProductId(id);
            addItem({
                variantId: variant,
                quantity: 1
            });
        }
    };
    var reviewData = (0,es.useQuery)([
        "get_review",
        handle,
        "reviews"
    ], function() {
        return util_fetchReviews(id);
    }, {
        enabled: (handle !== null && handle !== void 0 ? handle : "").length > 0,
        keepPreviousData: true
    });
    var ref2;
    var reviews = (ref2 = (ref = reviewData.data) === null || ref === void 0 ? void 0 : ref.product_reviews) !== null && ref2 !== void 0 ? ref2 : [];
    deliveryDate = deliveryDate ? new Date(deliveryDate) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/producten/".concat(handle),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (0,clsx_m/* default */.Z)({
                "flex flex-col h-full": newStyle
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)({
                    "relative second-thumbnail overflow-hidden": secondThumbnail
                }, {
                    "h-full flex flex-col": newStyle
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_thumbnail/* default */.Z, {
                        thumbnail: thumbnail,
                        objectFit: "cover",
                        containerClassName: (0,clsx_m/* default */.Z)("relative first-thumbnail overflow-hidden", {
                            "aspect-square md:aspect-[2/1]": doubleColl
                        }, {
                            "aspect-square": !doubleColl
                        }),
                        size: "full",
                        sale: price && price.price_type === "sale"
                    }),
                    secondThumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_thumbnail/* default */.Z, {
                        containerClassName: (0,clsx_m/* default */.Z)("absolute second-thumbnail__img top-0 z-10 opacity-0 hover:opacity-100 transition-all duration-500 ease-in-out", {
                            "aspect-[2/1]": doubleColl
                        }, {
                            "aspect-square": !doubleColl
                        }),
                        thumbnail: secondThumbnail,
                        size: "full"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("text-base-regular mt-2 text-slate-700", {
                            "font-semibold flex flex-col flex-grow": newStyle
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: (0,clsx_m/* default */.Z)("font-mono inline-block w-full", {
                                    " text-lg overflow-hidden whitespace-nowrap text-ellipsis product-h4-title": !newStyle
                                }, {
                                    "text-sm xl:text-md 2xlarge:text-lg": newStyle
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars, {
                                loading: reviewData.isLoading,
                                data: reviews
                            }),
                            !newStyle && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: presale ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-green-500 font-semibold",
                                    children: [
                                        "Pre-order",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        deliveryDate && "verwachte levertijd ".concat(deliveryDate.getDate(), " ").concat(deliveryDate.toLocaleString("nl-NL", {
                                            month: "long"
                                        }), " ").concat(deliveryDate.getFullYear())
                                    ]
                                }) : inStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-green-500 font-semibold",
                                    children: "Op voorraad"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-red-500 font-normal",
                                    children: "Niet op voorraad"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)("flex text-base gap-x-2", {
                                    "items-center mt-1": !newStyle
                                }, {
                                    "flex-col items-start mt-[auto]": newStyle
                                }),
                                children: price ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        price.price_type === "sale" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "line-through text-slate-800",
                                            children: price.original_price
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (0,clsx_m/* default */.Z)("font-semibold text-rose-500"),
                                            children: price.calculated_price
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-20 h-6 animate-pulse bg-gray-900"
                                })
                            }),
                            newStyle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                "aria-label": "Voeg toe aan winkelwagen",
                                className: (0,clsx_m/* default */.Z)("flex items-center justify-center min-h-[40px] px-2 py-1 transition-colors duration-200 disabled:opacity-50 disabled:hover:bg-gray-900 disabled:hover:text-white", "mt-5 bg-yellow-400 text-slate-900 hover:bg-yellow-300 border border-slate-800 rounded place-self-start"),
                                onClick: addToCart,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hi_index_esm/* HiPlusSm */.Yat, {
                                        size: 24
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineShoppingCart */.nom, {
                                        size: 24
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var product_preview = (ProductPreview);


/***/ }),

/***/ 63628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ thumbnail; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/modules/common/icons/placeholder-image.tsx





var PlaceholderImage = function(_param) {
    var _size = _param.size, size = _size === void 0 ? "20" : _size, _color = _param.color, color = _color === void 0 ? "currentColor" : _color, attributes = (0,_object_without_properties/* default */.Z)(_param, [
        "size",
        "color"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, attributes), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M15.3141 3.16699H4.68453C3.84588 3.16699 3.16602 3.84685 3.16602 4.6855V15.3151C3.16602 16.1537 3.84588 16.8336 4.68453 16.8336H15.3141C16.1527 16.8336 16.8326 16.1537 16.8326 15.3151V4.6855C16.8326 3.84685 16.1527 3.16699 15.3141 3.16699Z",
                stroke: color,
                strokeWidth: "1.53749",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.91699 9.16699C8.60735 9.16699 9.16699 8.60735 9.16699 7.91699C9.16699 7.22664 8.60735 6.66699 7.91699 6.66699C7.22664 6.66699 6.66699 7.22664 6.66699 7.91699C6.66699 8.60735 7.22664 9.16699 7.91699 9.16699Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.6667 12.5756L13.0208 9.1665L5 16.6665",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var placeholder_image = (PlaceholderImage);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/lib/util/loader.ts
var loader = __webpack_require__(44269);
;// CONCATENATED MODULE: ./src/modules/products/components/thumbnail/index.tsx






var Thumbnail = function(param) {
    var thumbnail = param.thumbnail, images = param.images, _size = param.size, size = _size === void 0 ? "small" : _size, _containerClassName = param.containerClassName, containerClassName = _containerClassName === void 0 ? null : _containerClassName, _objectFit = param.objectFit, objectFit = _objectFit === void 0 ? "cover" : _objectFit, _sale = param.sale, sale = _sale === void 0 ? false : _sale;
    var ref;
    var initialImage = thumbnail || (images === null || images === void 0 ? void 0 : (ref = images[0]) === null || ref === void 0 ? void 0 : ref.url);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(containerClassName !== null && containerClassName !== void 0 ? containerClassName : "relative aspect-[29/34]", {
            "w-[180px]": size === "small",
            "w-[290px]": size === "medium",
            "w-[440px]": size === "large",
            "w-full": size === "full"
        }),
        children: [
            sale && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-2 left-2 bg-gray-300 text-red-600 z-20 px-2 py-0.5 text-xs pointer-events-none antialiased tracking-[.22em]",
                children: "SALE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageOrPlaceholder, {
                image: initialImage,
                size: size,
                objectFit: objectFit
            })
        ]
    });
};
var ImageOrPlaceholder = function(param) {
    var image = param.image, size = param.size, objectFit = param.objectFit;
    return image ? typeof size === "number" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        loader: loader/* ImageLoader */.S,
        src: image,
        sizes: "(max-width: ".concat(size, "px) 100vw, ").concat(size, "px"),
        alt: "Thumbnail",
        layout: "fill",
        objectFit: objectFit !== null && objectFit !== void 0 ? objectFit : "cover",
        objectPosition: "center",
        className: "absolute inset-0",
        draggable: false,
        loading: "lazy"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        loader: loader/* ImageLoader */.S,
        src: image,
        alt: "Thumbnail",
        layout: "fill",
        objectFit: objectFit !== null && objectFit !== void 0 ? objectFit : "cover",
        objectPosition: "center",
        className: "absolute inset-0",
        draggable: false,
        loading: "lazy"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full h-full absolute inset-0 bg-gray-100 flex items-center justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(placeholder_image, {
            size: size === "small" ? 16 : 24
        })
    });
};
/* harmony default export */ var thumbnail = (Thumbnail);


/***/ }),

/***/ 15986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var SkeletonProductPreview = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "animate-pulse",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "aspect-[29/34] w-full bg-gray-100"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-base-regular mt-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-3/5 h-6 bg-gray-100"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-2/5 h-6 bg-gray-100 mt-2"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonProductPreview);


/***/ })

}]);